/* ============================================================================
   MAHA cart-mayoreo.js
   Estimación de mayoreo por línea en la página /cart.
   Reutiliza el MISMO endpoint público y token de HulkApps ya integrado en
   assets/card-product-v2.js (volumediscount.hulkapps.com/v1/products) y la
   MISMA clave de cache en sessionStorage (mahaVD:{pid}:{vid}) -> si el
   producto ya se consultó desde el PDP o una tarjeta, aquí no se repite la
   petición. No toca el motor de descuentos de HulkApps ni el checkout: todo
   lo que pinta este archivo es una ESTIMACIÓN visual: el importe real se
   confirma siempre en checkout.
   ============================================================================ */
(function () {
  'use strict';
  if (window.__mahaCartMayoreoInit) return;
  window.__mahaCartMayoreoInit = true;

  var HULK_URL = 'https://volumediscount.hulkapps.com/v1/products';
  var SHOP_DOMAIN = 'rafael-jjuan.myshopify.com';
  /* Token público ya embebido por la app en el frontend del tema (assets/wishlist.js:985) */
  var HULK_AUTH =
    'eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJpc3N1ZXJfbmFtZSIsImF1ZCI6ImNsaWVudCIsInRva2VuX25hbWUiOiJnZXRfcmVzcG9uc2UiLCJzaG9wX2lkIjo2ODI5OCwiY3JlYXRlX3RpbWUiOiIyMDI1LTAxLTI4IDEwOjIyOjAyICswMDAwIn0.3DiZKuoe26tjfnVbYIpF3YTtPo9ibVP_1xKRrVORaZw';
  var CACHE_TTL = 30 * 60 * 1000;
  var MAX_CONCURRENT = 4;

  /* MONEDA-MXN-MINUSCULA (2026-08-17): el sufijo va en MINUSCULA a proposito.
     No es una errata: el resto del carrito ya sale en minuscula porque
     .transcy-money lleva text-transform: lowercase desde CSS, pero lo que
     inyecta este archivo es texto plano sin esa clase y se quedaba en "MXN".
     Los 7 destinos de formatMoney() son todos del carrito (tarjetas y bloques
     de resumen, en /cart y en el drawer). Si se revierte a "MXN", vuelven a
     convivir las dos formas en la misma pantalla. */
  /* CARRITO-ACTUALIZACION-SIN-SALTO: la parte numerica se extrae a numeroMxn para
     poder reescribir SOLO la cifra dentro de un importe ya impreso por Liquid --
     conservando su envoltorio (.transcy-money) y su sufijo -- sin introducir un
     segundo formateador. formatMoney sigue siendo el unico formato completo. */
  function numeroMxn(value) {
    return Math.abs(value).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function formatMoney(value) {
    return (value < 0 ? '-' : '') + '$ ' + numeroMxn(value) + ' mxn';
  }

  /* ---------------- CART-IVA-FIX-1 ----------------
     La linea "s/IVA" de cada celda la imprime Liquid dividiendo item.final_price
     (unitario) e item.final_line_price (total) entre iva_div -- main-cart.liquid
     lineas 554-556 y 624-626. Esos valores son los de Shopify, que NO incluyen el
     descuento de mayoreo: HulkApps lo resuelve en runtime y solo existe en este
     archivo. Resultado: el s/IVA se quedaba dividiendo el precio SIN descuento.

     Aqui se reescribe esa linea con el importe de mayoreo ya calculado, usando
     exactamente las mismas variables que pintan el unitario y el total con
     mayoreo (unitCents y lineCents), asi que las tres cifras siempre cuadran.

     El gancho es la relacion de hermandad que este archivo ya usa para
     [data-mayoreo-base-price]: el <span class="cart-quote__sin-iva"> es hermano
     del bloque de mayoreo dentro del mismo <td>. Se excluye .unit-price porque
     la celda del unitario puede traer un segundo .cart-quote__sin-iva con el
     unit_price_measurement de Shopify, que es otro dato y no se toca.

     El texto " s/IVA" va en el MISMO nodo que el importe (no hay span hermano),
     asi que se reescribe completo. Se guarda el HTML original en
     __mayoreoFallback -- mismo patron que ya usan [data-mayoreo-saved] y el pie --
     para restaurarlo cuando la linea deja de alcanzar un tramo.
     ------------------------------------------------ */
  var IVA_DIV_FALLBACK = 1.16;

  function ivaDivisor() {
    var el = document.querySelector('[data-iva-div]');
    var v = el ? parseFloat(el.getAttribute('data-iva-div')) : NaN;
    return isFinite(v) && v > 0 ? v : IVA_DIV_FALLBACK;
  }

  function updateSinIva(cellEl, cents, hasTier) {
    if (!cellEl) return;
    var el = cellEl.querySelector('.cart-quote__sin-iva:not(.unit-price)');
    if (!el) return;
    if (typeof el.__mayoreoFallback !== 'string') el.__mayoreoFallback = el.innerHTML;
    if (hasTier && isFinite(cents)) {
      el.innerHTML = formatMoney(cents / 100 / ivaDivisor()) + ' S/IVA';
    } else {
      el.innerHTML = el.__mayoreoFallback;
    }
  }

  /* ---------------- HulkApps tiers (misma lógica que card-product-v2.js) ---------------- */
  var inFlight = 0;
  var fetchQueue = [];
  var memCache = {};

  function cacheKey(pid, vid) { return 'mahaVD:' + pid + ':' + vid; }

  function readSession(key) {
    try {
      var raw = sessionStorage.getItem(key);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || Date.now() - obj.t > CACHE_TTL) return null;
      return obj.tiers;
    } catch (e) { return null; }
  }

  function writeSession(key, tiers) {
    try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), tiers: tiers })); } catch (e) {}
  }

  function parseOfferLevels(data) {
    var tiers = [];
    try {
      if (!data || !data.eligible_offer || !data.eligible_offer.offer_levels) return tiers;
      if (data.eligible_offer.is_active === false) return tiers;
      var levels = JSON.parse(data.eligible_offer.offer_levels);
      for (var i = 0; i < levels.length; i++) {
        var row = levels[i];
        var type = (row[2] || '').toString();
        if (type.indexOf('%') === -1) continue;
        var min = parseInt(row[0], 10);
        var pct = parseFloat(row[1]);
        if (!isFinite(min) || !isFinite(pct) || min <= 0 || pct <= 0) continue;
        tiers.push({ min: min, percent: pct });
      }
      tiers.sort(function (a, b) { return a.min - b.min; });
    } catch (e) { /* respuesta inesperada -> sin tramos */ }
    return tiers;
  }

  function pump() {
    while (inFlight < MAX_CONCURRENT && fetchQueue.length) {
      inFlight++;
      fetchQueue.shift()();
    }
  }

  function fetchTiers(pid, vid) {
    var key = cacheKey(pid, vid);
    if (memCache[key]) return memCache[key];
    var cached = readSession(key);
    if (cached) {
      memCache[key] = Promise.resolve(cached);
      return memCache[key];
    }
    memCache[key] = new Promise(function (resolve) {
      fetchQueue.push(function () {
        var ctrl = 'AbortController' in window ? new AbortController() : null;
        var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 8000) : null;
        fetch(HULK_URL + '?product_id=' + pid + '&shop_domain=' + SHOP_DOMAIN + '&product_variants=' + vid, {
          method: 'GET',
          headers: { Authorization: HULK_AUTH, 'Content-Type': 'application/json' },
          signal: ctrl ? ctrl.signal : undefined,
        })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            var tiers = parseOfferLevels(data);
            writeSession(key, tiers);
            resolve(tiers);
          })
          .catch(function () { resolve([]); })
          .finally(function () {
            if (timer) clearTimeout(timer);
            inFlight--;
            pump();
          });
      });
      pump();
    });
    return memCache[key];
  }

  /* ---------------- cálculo por tramo ---------------- */
  function activeTier(tiers, qty) {
    var t = null;
    for (var i = 0; i < tiers.length; i++) { if (qty >= tiers[i].min) t = tiers[i]; }
    return t;
  }

  function nextTier(tiers, qty) {
    for (var i = 0; i < tiers.length; i++) { if (tiers[i].min > qty) return tiers[i]; }
    return null;
  }

  function tierUnitCents(baseCents, tier) {
    return Math.round(baseCents * (100 - tier.percent)) / 100;
  }

  /* ---------------- por línea ---------------- */
  function updateLine(row, tiers) {
    var qty = parseInt(row.getAttribute('data-quantity'), 10);
    var baseUnitCents = parseInt(row.getAttribute('data-unit-price-cents'), 10);
    if (!isFinite(qty) || qty <= 0 || !isFinite(baseUnitCents)) return null;

    var tier = tiers && tiers.length ? activeTier(tiers, qty) : null;
    var next = tiers && tiers.length ? nextTier(tiers, qty) : null;

    var unitBlocks = row.querySelectorAll('[data-mayoreo-unit-price]');
    for (var i = 0; i < unitBlocks.length; i++) {
      var block = unitBlocks[i];
      var baseEl = block.parentElement.querySelector('[data-mayoreo-base-price]');
      var valEl = block.querySelector('[data-mayoreo-unit-value]');
      if (tier) {
        var unitCents = tierUnitCents(baseUnitCents, tier);
        if (valEl) valEl.innerHTML = formatMoney(unitCents / 100);
        block.hidden = false;
        if (baseEl) baseEl.classList.add('is-mayoreo-struck');
        /* CART-IVA-FIX-1: s/IVA unitario = precio de mayoreo / iva_div */
        updateSinIva(block.parentElement, unitCents, true);
      } else {
        block.hidden = true;
        if (baseEl) baseEl.classList.remove('is-mayoreo-struck');
        /* CART-IVA-FIX-1: sin tramo, vuelve al valor que imprimio Liquid */
        updateSinIva(block.parentElement, 0, false);
      }
    }

    var totalBlocks = row.querySelectorAll('[data-mayoreo-total-price]');
    for (var j = 0; j < totalBlocks.length; j++) {
      var tBlock = totalBlocks[j];
      var tBaseEl = tBlock.parentElement.querySelector('[data-mayoreo-base-total]');
      var tValEl = tBlock.querySelector('[data-mayoreo-line-total-value]');
      if (tier) {
        var lineCents = tierUnitCents(baseUnitCents, tier) * qty;
        if (tValEl) tValEl.innerHTML = formatMoney(lineCents / 100);
        tBlock.hidden = false;
        if (tBaseEl) tBaseEl.classList.add('is-mayoreo-struck');
        /* CART-IVA-FIX-1: s/IVA del total de linea = total de mayoreo / iva_div */
        updateSinIva(tBlock.parentElement, lineCents, true);
      } else {
        tBlock.hidden = true;
        if (tBaseEl) tBaseEl.classList.remove('is-mayoreo-struck');
        /* CART-IVA-FIX-1: sin tramo, vuelve al valor que imprimio Liquid */
        updateSinIva(tBlock.parentElement, 0, false);
      }
    }

    /* formato de venta real de la línea (min/step, mismo metafield que PDP):
       "faltan N" no puede referirse a piezas sueltas si el producto no se
       vende de 1 en 1 -- hay que hablar de la siguiente cantidad COMPRABLE. */
    var qtyMin = parseInt(row.getAttribute('data-qty-min'), 10);
    var qtyStep = parseInt(row.getAttribute('data-qty-step'), 10);
    if (!isFinite(qtyMin) || qtyMin < 1) qtyMin = 1;
    if (!isFinite(qtyStep) || qtyStep < 1) qtyStep = 1;

    var nextEls = row.querySelectorAll('[data-mayoreo-next-tier]');
    for (var k = 0; k < nextEls.length; k++) {
      var el = nextEls[k];
      if (next) {
        /* siguienteCantidadValida = min + ceil((umbral - min) / step) * step */
        var nextValidQty = qtyMin + Math.ceil((next.min - qtyMin) / qtyStep) * qtyStep;
        var missingPieces = nextValidQty - qty;
        var pctText = next.percent % 1 === 0 ? next.percent : next.percent.toFixed(1);
        /* CART-VISUAL-FIXES-2: un solo formato de mensaje.
             "Agrega {faltan} {etiqueta} mas y obten {pct}% en cada producto"
           La etiqueta sale de data-step-label del <tr>; si el atributo no esta,
           cae a "piezas". missingPieces ya es la diferencia hasta la siguiente
           cantidad COMPRABLE (multiplo de qtyStep desde qtyMin), asi que la
           cifra sigue siendo una cantidad que el cliente puede pedir de verdad
           aunque el texto ya no hable de paquetes. */
        var stepLabel = row.getAttribute('data-step-label');
        if (!stepLabel) stepLabel = 'piezas';
        el.textContent =
          'Agrega ' + missingPieces + ' ' + stepLabel + ' más y obtén ' + pctText + '% en cada producto';
        el.hidden = false;
      } else {
        el.hidden = true;
        el.textContent = '';
      }
    }

    /* ---------------- columna "Ahorrado" (CARRITO-AHORRO-REFERENCIA-UNICA 2026-08-24) ----------------
       UNA SOLA referencia, decision del dueno tras el censo del 2026-08-24:
       todo ahorro se mide contra precio_de_lista (compare_at si existe y
       supera al precio de venta; si no, el precio de venta -- calculado en
       Liquid, sections/main-cart.liquid, y expuesto aqui como
       data-precio-lista-unit-cents, SIEMPRE presente, nunca 0). Antes esta
       celda cambiaba de definicion segun hubiera tramo o no -- compare_at
       sin tramo, SOLO mayoreo con tramo, perdiendo el compare_at por el
       camino -- y por eso "Precio de lista - Ahorrado" del resumen no
       cuadraba con lo que decia esta columna. Formula unica, con tramo o sin
       el:
         ahorro = (precio_de_lista - precio_final_con_tramo) x cantidad
         precio_final_con_tramo = tierUnitCents(venta, tier) si hay tramo,
                                   si no, el precio de venta mismo
       El % del distintivo es ahorro / (precio_de_lista x cantidad), NO el
       porcentaje crudo del tramo de HulkApps: con compare_at de por medio
       el ahorro real es mayor que el tramo por si solo (ver el censo: 28%,
       no el 10% del tramo).
       Ya NO hace falta __mayoreoFallback para esta celda: el resultado se
       calcula entero cada vez, nunca se restaura un HTML guardado. */
    var savedEls = row.querySelectorAll('[data-mayoreo-saved]');
    for (var s = 0; s < savedEls.length; s++) {
      var savedEl = savedEls[s];
      var listaUnitUL = parseInt(row.getAttribute('data-precio-lista-unit-cents'), 10);
      var precioFinalUnitUL = tier ? tierUnitCents(baseUnitCents, tier) : baseUnitCents;
      if (isFinite(listaUnitUL) && listaUnitUL > precioFinalUnitUL) {
        var savedCentsUL = Math.round((listaUnitUL - precioFinalUnitUL) * qty);
        var pctUL = Math.round((savedCentsUL / (listaUnitUL * qty)) * 100);
        /* CART-STYLE-FIXES: la columna Ahorrado va sin linea s/IVA. Con ella se
           quito tambien la lectura de data-iva-div, que solo existia para eso. */
        savedEl.innerHTML =
          '<span class="cart-quote__disc-amount ctf-disc-amount">−' +
          formatMoney(savedCentsUL / 100) +
          '</span>' +
          '<span class="cart-quote__badge-pct ctf-badge-pct">' + pctUL + '%</span>';
      } else {
        savedEl.innerHTML = '<span class="cart-quote__empty" aria-hidden="true">&mdash;</span><span class="visually-hidden">Sin descuento</span>';
      }
    }

    return { tier: tier, qty: qty, baseUnitCents: baseUnitCents };
  }

  /* ---------------- resumen del carrito (suma real por línea, sin repartir) ---------------- */
  function updateSummary(root) {
    var scope = root || document;
    /* CART-TOTALS-REDESIGN: el pie ya no tiene una fila suelta "Total estimado
       con mayoreo". El ahorro va en su propia fila (TOTAL AHORRADO) y el importe
       con mayoreo se escribe encima del TOTAL A PAGAR. Por eso la guarda de
       salida solo exige el subtotal: antes exigia tambien los tres elementos de
       esa fila y, al quitarlos del Liquid, esta funcion habria salido siempre
       por el return temprano sin escribir nada. */
    var subtotalEl = scope.querySelector('[data-cart-subtotal-cents]');
    if (!subtotalEl) return;

    var subtotalCents = parseInt(subtotalEl.getAttribute('data-cart-subtotal-cents'), 10);
    if (!isFinite(subtotalCents)) return;

    var savedBlock = scope.querySelector('[data-mayoreo-saved-block]');
    var savedAmountEl = scope.querySelector('[data-mayoreo-saved-amount]');
    var savedPctEl = scope.querySelector('[data-mayoreo-saved-pct]');
    var finalPriceEl = scope.querySelector('[data-mayoreo-final-price]');
    var sinIvaEl = scope.querySelector('[data-mayoreo-sin-iva]');
    var noteEl = scope.querySelector('[data-cart-mayoreo-note]');

    /* Se guarda lo que imprimio Liquid para poder restaurarlo si el tramo deja
       de aplicar (p. ej. al bajar la cantidad). Sin esto, el total se quedaria
       con el importe rebajado aunque ya no corresponda. */
    if (finalPriceEl && typeof finalPriceEl.__mayoreoFallback !== 'string') {
      finalPriceEl.__mayoreoFallback = finalPriceEl.innerHTML;
    }
    if (sinIvaEl && typeof sinIvaEl.__mayoreoFallback !== 'string') {
      sinIvaEl.__mayoreoFallback = sinIvaEl.innerHTML;
    }

    var rows = lineRows(scope);

    /* savingsCents: SOLO mayoreo (igual formula que siempre tuvo esta
       funcion, sin cambios) -- es lo unico que reduce lo que Shopify cobra
       de verdad. compare_at NUNCA reduce el cobro: es referencia, no
       descuento aplicado. */
    var savingsCents = 0;
    var anyTier = false;
    rows.forEach(function (row) {
      var state = row.__mayoreoState;
      if (state && state.tier) {
        anyTier = true;
        var baseLine = state.baseUnitCents * state.qty;
        var estLine = tierUnitCents(state.baseUnitCents, state.tier) * state.qty;
        savingsCents += baseLine - estLine;
      }
    });
    var hayReduccionMayoreo = anyTier && savingsCents > 0 && savingsCents < subtotalCents;
    var finalCentsSinEnvio = hayReduccionMayoreo ? (subtotalCents - savingsCents) : subtotalCents;

    /* Envio (COTIZACION-AJUSTE-COLUMNAS-Y-GRIS 2026-08-24, P7 -- decision
       del dueno): "Total a pagar" nunca habia incluido el envio, aunque la
       caja vive justo debajo de "Costo de envio" dando a entender que si.
       Confirmado el defecto contra /cart.js antes de tocar esto. Se lee el
       NUMERO limpio que aplicarTarifa() ya guardo en dataset.shipCents
       (sections/main-cart.liquid) -- nunca se re-parsea el texto formateado
       ni se mira una clase o un estilo para decidir si esta aplicado. */
    var shipValEl = document.querySelector('.ctf-total-row--shipping .ctf-total-row__value');
    var envioCents = (shipValEl && shipValEl.dataset && shipValEl.dataset.shipApplied === '1')
      ? (parseInt(shipValEl.dataset.shipCents, 10) || 0)
      : 0;
    var finalCents = finalCentsSinEnvio + envioCents;

    /* CARRITO-AHORRO-REFERENCIA-UNICA 2026-08-24: PRECIO DE LISTA se
       recalcula siempre fresco (suma de precio_de_lista x cantidad linea a
       linea) porque la cantidad pudo cambiar por el stepper desde que
       Liquid imprimio el carrito -- cart_precio_lista_total del Liquid ya
       quedo desactualizado en ese momento. AHORRADO TOTAL es la
       CONSECUENCIA algebraica de restar finalCentsSinEnvio (arriba, ya
       correcto y server-anclado) de este total -- nunca se calcula por
       separado, y NUNCA incluye el envio (el envio no es un descuento),
       para que "lista - ahorrado + envio = total a pagar" se cumpla
       SIEMPRE, no por coincidencia (ver la prueba algebraica en
       sections/main-cart.liquid, junto a donde se declara el acumulador). */
    var listaTotalCents = 0;
    rows.forEach(function (row) {
      var listaUnit = parseInt(row.getAttribute('data-precio-lista-unit-cents'), 10);
      var qtyFila = parseInt(row.getAttribute('data-quantity'), 10);
      if (isFinite(listaUnit) && isFinite(qtyFila)) listaTotalCents += listaUnit * qtyFila;
    });
    var ahorroTotalCents = listaTotalCents - finalCentsSinEnvio;

    /* PRECIO DE LISTA (decision del dueno, 2026-08-24, sustituye a la
       anterior): el bloque ya NO se oculta -- aparecer/desaparecer hacia
       saltar el panel entero. Lo unico que cambia con el ahorro es el
       TACHADO del importe (estilo en linea text-decoration, NO una clase de
       cart-styles.css, que esta tarea no toca). TOTAL AHORRADO si sigue
       mostrandose/ocultandose con la clase is-visible que ya trae desde
       antes -- ese mecanismo no cambia. Ambos usan la MISMA condicion
       (misma magnitud, ver arriba). */
    var listaValueEl = scope.querySelector('.ctf-total-row--list .ctf-total-row__value');
    var hayAhorro = ahorroTotalCents > 0 && listaTotalCents > 0;
    if (listaValueEl) {
      var tagLista = listaValueEl.querySelector('.ctf-iva-tag');
      listaValueEl.innerHTML = formatMoney(listaTotalCents / 100) + (tagLista ? tagLista.outerHTML : '');
      listaValueEl.style.textDecoration = hayAhorro ? 'line-through' : '';
    }
    if (hayAhorro) {
      if (savedBlock) savedBlock.classList.add('is-visible');
      if (savedAmountEl) savedAmountEl.innerHTML = '−' + formatMoney(ahorroTotalCents / 100);
      /* Porcentaje entero, MISMA formula que la columna por linea:
         ahorro / (precio_de_lista x cantidad). Ya no es el % crudo del
         tramo de HulkApps -- con compare_at de por medio el ahorro real es
         mayor que el tramo solo (ver el censo: 28%, no el 10% del tramo). */
      if (savedPctEl) savedPctEl.textContent = '−' + Math.round((ahorroTotalCents / listaTotalCents) * 100) + '%';
    } else {
      if (savedBlock) savedBlock.classList.remove('is-visible');
      if (savedAmountEl) savedAmountEl.innerHTML = '&mdash;';
      if (savedPctEl) savedPctEl.textContent = '';
    }

    /* Se calcula y escribe "Total a pagar" si hay reduccion de mayoreo O
       envio aplicado -- son independientes, cualquiera de los dos basta.
       Sin ninguno de los dos, se restaura el fallback de Liquid tal cual
       (mismo comportamiento de siempre para el caso sin cambios). */
    if (!hayReduccionMayoreo && envioCents === 0) {
      if (finalPriceEl) finalPriceEl.innerHTML = finalPriceEl.__mayoreoFallback;
      if (sinIvaEl) sinIvaEl.innerHTML = sinIvaEl.__mayoreoFallback;
      if (noteEl) { noteEl.textContent = ''; noteEl.hidden = true; }
      return;
    }

    if (finalPriceEl) finalPriceEl.innerHTML = formatMoney(finalCents / 100);
    if (sinIvaEl) {
      var ivaDiv = parseFloat(sinIvaEl.getAttribute('data-iva-div'));
      if (!isFinite(ivaDiv) || ivaDiv <= 0) ivaDiv = 1.16;
      sinIvaEl.innerHTML = formatMoney(finalCents / 100 / ivaDiv) + ' sin IVA';
    }
    /* La nota de "descuento definitivo" es sobre el TRAMO de mayoreo, no
       sobre el envio -- solo aparece cuando de verdad hay reduccion de
       mayoreo, aunque el envio tambien haya disparado este recalculo. */
    if (noteEl) {
      noteEl.textContent = hayReduccionMayoreo ? 'El descuento definitivo se aplicará y confirmará en checkout.' : '';
      noteEl.hidden = !hayReduccionMayoreo;
    }
  }

  function lineRows(scope) {
    return scope.querySelectorAll('[data-mayoreo-line]');
  }

  /* ---------------- orquestación ---------------- */
  function refreshAll(scope) {
    var rows = lineRows(scope);
    if (!rows.length) {
      updateSummary(scope);
      return;
    }
    var pending = rows.length;
    rows.forEach(function (row) {
      var pid = row.getAttribute('data-product-id');
      var vid = row.getAttribute('data-variant-id');
      fetchTiers(pid, vid)
        .then(function (tiers) { row.__mayoreoState = updateLine(row, tiers); })
        .catch(function () { row.__mayoreoState = updateLine(row, []); })
        .finally(function () {
          pending--;
          if (pending === 0) updateSummary(scope);
        });
    });
  }

  /* recálculo instantáneo (sin red) cuando el usuario cambia la cantidad:
     los tramos ya quedaron en cache tras el primer fetch de esa línea */
  /* CARRITO-ACTUALIZACION-SIN-SALTO: el cuerpo de este listener se EXTRAE a
     recalcularLinea para poder llamarlo tambien desde el controlador de +/- y
     desde la reversion de un fallo, en vez de escribir una segunda ruta de
     recalculo. El listener se queda igual y ahora solo la invoca. */
  function recalcularLinea(row) {
    var pid = row.getAttribute('data-product-id');
    var vid = row.getAttribute('data-variant-id');
    return fetchTiers(pid, vid).then(function (tiers) {
      row.__mayoreoState = updateLine(row, tiers);
      updateSummary(document);
    });
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('.quantity__input');
    if (!input) return;
    var row = input.closest('[data-mayoreo-line]');
    if (!row) return;
    var qty = parseInt(input.value, 10);
    if (!isFinite(qty) || qty <= 0) return;
    /* CARRITO-ACTUALIZACION-SIN-SALTO: la cantidad CONFIRMADA POR EL SERVIDOR se
       captura aqui, justo antes de pisarla, y solo la primera vez. Es a la que
       revierte revertirLinea cuando una peticion falla. Va en el listener y no en
       el arranque para que tambien la tengan las filas que nazcan de un repintado
       posterior -- aplicar un cupon, por ejemplo, si rehace la seccion. */
    if (!isFinite(row.__mahaQtyServidor)) {
      row.__mahaQtyServidor = parseInt(row.getAttribute('data-quantity'), 10);
    }
    row.setAttribute('data-quantity', String(qty));
    recalcularLinea(row);
  });

  /* ==========================================================================
     CARRITO-ACTUALIZACION-SIN-SALTO  ·  2026-08-20

     QUE SE MIDIO ANTES DE ESCRIBIR NADA (55 lineas, 11,275 unidades):
       · El nodo que scrollea es UNO: div.cart-quote__table-scroll
         (overflow-y:auto, max-height 600px; scrollHeight 11194 / clientHeight
         600). Todos sus ancestros salen overflow-y: visible.
       · Quien lo destruye: CartItems.onCartUpdate (assets/cart.js:237) hace
         mainCart.innerHTML = updatedElement.innerHTML -- 389,545 caracteres de
         una sola vez, 3 hijos fuera y 3 dentro. El contenedor desplazable vive
         DENTRO de ese innerHTML: no se "reinicia", se destruye y nace otro con
         scrollTop 0. Medido: 5297 -> 0, y el foco pasaba de BODY a A (trapFocus).
       · El POST /cart/change pesaba 713,501 bytes porque updateQuantity pide el
         paquete `sections` de la Section Rendering API.
       · Mediana clic -> importes estables: 2107 ms (maximo 2787).

     LA SOLUCION: no hay nada que restaurar si no se destruye nada. Se quitan las
     DOS causas -- el paquete `sections` y el repintado -- y los numeros que
     imprimio Liquid se parchean en sitio desde el JSON que /cart/change.js ya
     devuelve. Cero anclaje por pixeles: las filas CAMBIAN DE ALTURA cuando el
     aviso verde de mayoreo aparece o desaparece, asi que cualquier solucion que
     guarde y reponga scrollTop fallaria justo en ese caso.

     POR QUE VIVE AQUI Y NO EN sections/main-cart.liquid: ese archivo lo esta
     editando otra sesion y cada PUT es un riesgo de choque. Es el mismo criterio
     que ya documenta CARRITO-COLUMNA-SKU-AJUSTADA mas abajo en este archivo.
     Y assets/cart.js NO se toca: se parchean sus prototipos desde aqui, que es
     de MAHA y carga DESPUES (los dos con defer, orden garantizado por el
     estandar, main-cart.liquid lineas 10-11).

     EL LINDE CON EL DRAWER, que es la mitad del riesgo de este cambio: los dos
     parches solo cambian de comportamiento cuando ESA instancia de <cart-items>
     esta dentro de un <main-cart>. En /cart lo esta (main-cart.liquid:180
     envuelve al :204). El <cart-items> del drawer (cart-drawer.liquid:140) no
     tiene <main-cart> por encima, cae en la rama del original y conserva TODO:
     su 'cart:grouped-sections', su paquete `sections` y su repintado.

     LO QUE SE CONSERVA A PROPOSITO:
       · el pubsub cartUpdate se sigue publicando -- de el viven el badge del
         header (theme.js, class CartCount), el contador del titulo y el resto
         de suscriptores;
       · el evento DOM 'cart:updated' se sigue disparando -- de el dependen
         limpiarFilaEnvio (la tarifa de envio deja de corresponder al cambiar el
         peso, y borrarla es el comportamiento correcto y el de hoy),
         CARRITO-COLUMNA-SKU-AJUSTADA, el pie fijo movil y
         CARRITO-RUEDA-NO-ARRASTRA (.has-vscroll / .has-hscroll).

     REVERTIR: borrar este bloque completo. Sin el, los prototipos del tema
     quedan intactos y vuelve el comportamiento anterior.
     ========================================================================== */

  var TEXTO_FALLO = 'No pudimos actualizar. Intenta de nuevo.';
  var TEXTO_RITMO = 'Demasiados cambios seguidos. Espera un momento.';

  /* El parche solo aplica al carrito de la PAGINA, nunca al del drawer. */
  function esCarritoDePagina(el) {
    return !!(el && el.closest && el.closest('main-cart'));
  }

  /* ---------------- foco ----------------
     Con esta solucion el DOM no se destruye, asi que el foco no deberia moverse
     solo. Se guarda y se repone igualmente: es la garantia de que se puede
     pulsar + cinco veces sin volver a apuntar con el raton, pase lo que pase
     con el resto del repintado parcial. focus({preventScroll:true}) es
     obligatorio: sin el, devolver el foco desplazaria el contenedor y
     reintroduciria el salto por la puerta de atras. */
  function guardarFoco() {
    var a = document.activeElement;
    if (!a || a === document.body || !a.closest) return null;
    var row = a.closest('[data-mayoreo-line]');
    if (!row || !row.id) return null;
    var papel = a.getAttribute('name');
    if (!papel && a.classList.contains('quantity__input')) papel = '@input';
    if (!papel) return null;
    var inicio = null, fin = null;
    /* selectionStart lanza InvalidStateError en <input type="number">: se
       intenta y se ignora, en vez de suponer que existe. */
    try { inicio = a.selectionStart; fin = a.selectionEnd; } catch (e) {}
    return { filaId: row.id, papel: papel, inicio: inicio, fin: fin };
  }

  function restaurarFoco(f) {
    if (!f) return;
    var row = document.getElementById(f.filaId);
    if (!row) return;
    var el = f.papel === '@input'
      ? row.querySelector('.quantity__input')
      : row.querySelector('[name="' + f.papel + '"]');
    if (!el || el === document.activeElement) return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
    if (f.inicio != null && el.setSelectionRange) {
      try { el.setSelectionRange(f.inicio, f.fin); } catch (e) {}
    }
  }

  /* ---------------- aviso por fila (SOLO fallos de transporte) ----------------
     Un 429 era MUDO: medido, 7 de 10 clics seguidos lo devolvieron y ni la tabla
     se movia ni el cliente se enteraba. Aqui el aviso SI vale, porque "intenta de
     nuevo" es verdad. Los rechazos de Shopify (sin existencias) NO pasan por
     aqui: van por la via nativa, ver el desenlace 2 de updateQuantity.

     DONDE VA Y POR QUE: la primera version lo puso en la celda de CANTIDAD, que
     es la mas estrecha de la tabla, y el cuadro empujaba la columna de precio y
     estiraba la fila. Un aviso que cambia el alto de la fila vuelve a mover el
     recorrido, que es justo lo que arregla esta tarea. Ahora va en POSICION
     ABSOLUTA dentro de la celda de PRODUCTO (la mas ancha), asi que no ocupa
     nada en el flujo y el alto de la fila no cambia ni un pixel.

     Ambar, no rojo de alarma: es un reintento, no un error del cliente.
     Los estilos van en linea a proposito: este cambio no toca cart-styles.css,
     asi que el aviso no puede depender de una clase que no existe. */
  /* ---------------- atenuar fila (CARRITO-CART-CHANGE-URL-JS, Fase 4) ----------------
     El stepper +/- ya se actualiza en sitio, verificado en vivo a 0px de
     salto. La ruedita del bote de basura sobraba ahi -- giraba ~900ms sin
     que nada se estuviera "cargando" de verdad (el numero ya cambio en el
     input al instante). Se sustituye por una atenuacion ligera de TODA la
     fila, sin tocar tamano ni layout: solo opacity, con estilos en linea
     (mismo criterio que avisar() unas lineas arriba: no depende de una clase
     que viva en cart-styles.css). SOLO se usa en el camino del stepper --
     borrarLinea() sigue usando showLoader/hideLoader (la ruedita del bote),
     porque ahi si hay una espera real de red antes de saber si se pudo. */
  function atenuarFila(line) {
    var row = document.getElementById('CartItem-' + line);
    if (!row) return;
    row.style.transition = 'opacity 150ms ease';
    row.style.opacity = '0.6';
  }

  function quitarAtenuacion(line) {
    var row = document.getElementById('CartItem-' + line);
    if (!row) return;
    row.style.opacity = '';
  }

  function quitarAviso(row) {
    if (!row) return;
    var previo = row.querySelector('[data-maha-aviso]');
    if (!previo) return;
    clearTimeout(previo.__temporizador);
    var celda = previo.parentElement;
    previo.remove();
    if (celda && celda.__mahaPosicionPrevia !== undefined) {
      celda.style.position = celda.__mahaPosicionPrevia;
      delete celda.__mahaPosicionPrevia;
    }
  }

  function avisar(row, texto) {
    if (!row) return;
    quitarAviso(row);
    var celda = row.querySelector('.cart-quote__cell--product') || row.querySelector('.cart-quote__cell');
    if (!celda) return;
    if (getComputedStyle(celda).position === 'static') {
      celda.__mahaPosicionPrevia = celda.style.position;
      celda.style.position = 'relative';
    }
    var el = document.createElement('span');
    el.setAttribute('data-maha-aviso', '');
    el.setAttribute('role', 'status');
    el.textContent = texto;
    el.style.cssText = 'position:absolute;left:0;right:8px;bottom:1px;z-index:3;' +
      'font-size:11px;line-height:1.35;color:#7a4b00;background:#fff8e6;' +
      'border:1px solid #f2d68a;border-radius:6px;padding:2px 6px;pointer-events:none';
    celda.appendChild(el);
    el.__temporizador = setTimeout(function () { quitarAviso(row); }, 6000);
  }

  /* ---------------- parche en sitio, desde el JSON del carrito ----------------
     Todos los numeros salen de /cart/change.js, que es la fuente autoritativa.
     No se recalcula nada en local salvo el reescalado del Ahorrado de Liquid,
     que es lineal por construccion (desc_unitario x cantidad) y cuyo importe
     unitario NO viene en el JSON: sale de variant.compare_at_price. */
  function aplicarEnSitio(cart, linea) {
    var foco = guardarFoco();
    var div = ivaDivisor();

    /* `linea` es el indice 1-based que usa el tema (data-index del input) y el
       orden de cart.items es el mismo. Se comprueba en vez de darlo por hecho:
       si la variante no cuadra, se busca por id antes que escribir cifras en la
       fila equivocada, que es el peor fallo posible aqui. */
    var row = document.getElementById('CartItem-' + linea);
    var item = cart.items && cart.items[linea - 1];
    if (row && item && String(item.variant_id) !== String(row.getAttribute('data-variant-id'))) {
      item = null;
      for (var b = 0; b < cart.items.length; b++) {
        if (String(cart.items[b].variant_id) === String(row.getAttribute('data-variant-id'))) { item = cart.items[b]; break; }
      }
    }
    if (row && item) {
      row.setAttribute('data-quantity', String(item.quantity));
      row.__mahaQtyServidor = item.quantity;
      /* La CLAVE de linea de Shopify. Es la identidad fuerte que usa
         porQueNoSePuedeEnSitio para detectar que una linea desaparecio: el
         data-variant-id no distingue dos lineas de la misma variante con
         propiedades distintas, y la clave si. */
      if (item.key) row.__mahaKey = item.key;
      quitarAviso(row);   /* un cambio que si entro deja sin sentido el aviso anterior */
      var input = row.querySelector('.quantity__input');
      if (input) {
        if (String(input.value) !== String(item.quantity)) input.value = item.quantity;
        /* defaultValue tambien, y no es cosmetico: setValidity() del tema hace
           target.value = target.defaultValue, y defaultValue es el que imprimio
           Liquid al cargar. Sin refrescarlo, un rechazo posterior repone una
           cantidad vieja -- el tema ya lo hacia mal por su cuenta. */
        input.defaultValue = String(item.quantity);
      }

      /* Total de linea impreso por Liquid. updateLine solo escribe el bloque de
         mayoreo; este es el importe base y sin esto se queda en el de la
         cantidad anterior. */
      var baseTotal = row.querySelector('[data-mayoreo-base-total]');
      if (baseTotal) baseTotal.innerHTML = formatMoney(item.final_line_price / 100);

      /* La linea s/IVA de la celda TOTAL: solo el fallback. El texto visible lo
         decide updateLine un momento despues, segun haya tramo o no. */
      var celdaTotal = row.querySelector('.cart-quote__cell--total');
      var sinIvaTotal = celdaTotal && celdaTotal.querySelector('.cart-quote__sin-iva:not(.unit-price)');
      if (sinIvaTotal) {
        sinIvaTotal.__mayoreoFallback = formatMoney(item.final_line_price / 100 / div) + ' s/IVA';
      }

      /* El s/IVA del UNITARIO no cambia con la cantidad, pero si el precio
         unitario efectivo cambiara (un descuento de carrito), tambien queda al dia. */
      var celdaUnit = row.querySelector('.cart-quote__cell--unit');
      var sinIvaUnit = celdaUnit && celdaUnit.querySelector('.cart-quote__sin-iva:not(.unit-price)');
      if (sinIvaUnit) {
        sinIvaUnit.__mayoreoFallback = formatMoney(item.final_price / 100 / div) + ' s/IVA';
      }

      /* Columna Ahorrado (CARRITO-AHORRO-REFERENCIA-UNICA 2026-08-24): ya no
         se reescala un HTML guardado por razon de cantidades -- se recalcula
         entera aqui mismo con precio_de_lista (estatico, no cambia con la
         cantidad) contra el precio final CON el ultimo tramo conocido
         (row.__mayoreoState, valido hasta que recalcularLinea() lo reemplace
         un instante despues, mas abajo en esta misma funcion). Es la MISMA
         formula que usa updateLine(): (lista - final_con_tramo) x cantidad.
         data-unit-price-cents se refresca primero al precio que ACABA de
         confirmar el servidor, para que ese y cualquier recalculo posterior
         partan del mismo numero. */
      row.setAttribute('data-unit-price-cents', String(item.final_price));
      var savedEl = row.querySelector('[data-mayoreo-saved]');
      if (savedEl) {
        var listaUnitAES = parseInt(row.getAttribute('data-precio-lista-unit-cents'), 10);
        var tierConocido = row.__mayoreoState && row.__mayoreoState.tier;
        var precioFinalUnitAES = tierConocido ? tierUnitCents(item.final_price, tierConocido) : item.final_price;
        if (isFinite(listaUnitAES) && listaUnitAES > precioFinalUnitAES) {
          var savedCentsAES = Math.round((listaUnitAES - precioFinalUnitAES) * item.quantity);
          var pctAES = Math.round((savedCentsAES / (listaUnitAES * item.quantity)) * 100);
          savedEl.innerHTML =
            '<span class="cart-quote__disc-amount ctf-disc-amount">−' + formatMoney(savedCentsAES / 100) + '</span>' +
            '<span class="cart-quote__badge-pct ctf-badge-pct">' + pctAES + '%</span>';
        } else {
          savedEl.innerHTML = '<span class="cart-quote__empty" aria-hidden="true">&mdash;</span><span class="visually-hidden">Sin descuento</span>';
        }
      }
    }

    /* --- resumen: los importes de Liquid que dependen del total del carrito --- */
    var total = cart.total_price;
    var grand = document.querySelector('[data-cart-subtotal-cents]');
    if (grand && isFinite(total)) {
      /* El atributo es de donde updateSummary lee el total en centavos: si no se
         actualiza, TOTAL AHORRADO y TOTAL A PAGAR se calculan sobre el viejo. */
      grand.setAttribute('data-cart-subtotal-cents', String(total));
      grand.__mayoreoFallback = formatMoney(total / 100);
    }
    /* CARRITO-PRECIO-LISTA-CONDICIONAL 2026-08-24: aqui ANTES se escribia
       total/100 (el total A PAGAR) directamente sobre PRECIO DE LISTA -- eso
       es correcto SOLO cuando no hay ningun ahorro real, que es el caso de
       siempre en esta tienda, pero era la MISMA causa por la que el bloque
       salia tachado sin descuento. Ahora que PRECIO DE LISTA es una MAGNITUD
       (pagar + ahorro real de compare_at), su recalculo linea a linea vive en
       updateSummary (mas abajo en este archivo), que corre justo despues de
       esto (via recalcularLinea o directo). Aqui ya no se toca ese nodo.
       Ver updateSummary para el porque no se hace aqui. */
    var sinIvaTotalCarrito = document.querySelector('[data-mayoreo-sin-iva]');
    if (sinIvaTotalCarrito && isFinite(total)) {
      var d2 = parseFloat(sinIvaTotalCarrito.getAttribute('data-iva-div'));
      if (!isFinite(d2) || d2 <= 0) d2 = div;
      sinIvaTotalCarrito.__mayoreoFallback = formatMoney(total / 100 / d2) + ' sin IVA';
    }
    /* El <tfoot> lleva su propio Subtotal impreso por Liquid. */
    var subVal = document.querySelector('.cart-quote__subtotal-value');
    if (subVal && isFinite(total)) subVal.innerHTML = formatMoney(total / 100);
    var subSinIva = document.querySelector('.cart-quote__subtotal-cell .cart-quote__sin-iva');
    if (subSinIva && isFinite(total)) subSinIva.innerHTML = '(' + formatMoney(total / 100 / div) + ' s/IVA)';

    /* El mayoreo se recalcula con la MISMA ruta que ya existia para el cambio de
       cantidad (recalcularLinea), no con una segunda copia. Despues,
       updateSummary sobre todo el documento. */
    if (row) recalcularLinea(row);
    else updateSummary(document);

    restaurarFoco(foco);
  }

  /* ---------------- devolver la fila a la ultima cantidad confirmada ----------------
     El listener de 'change' ya piso data-quantity con la cantidad optimista, asi
     que hay que devolver TRES cosas, no solo el input: el atributo del <tr>, el
     campo, y el recalculo de mayoreo que colgaba de ellos.
     Se usa en los DOS caminos de fallo; lo unico que cambia entre ellos es el
     mensaje, que va aparte. */
  function devolverFilaAlUltimoValorConfirmado(linea) {
    var row = document.getElementById('CartItem-' + linea);
    if (!row) return null;
    var qty = row.__mahaQtyServidor;
    if (isFinite(qty) && qty > 0) {
      row.setAttribute('data-quantity', String(qty));
      var input = row.querySelector('.quantity__input');
      if (input) {
        input.value = qty;
        /* defaultValue tambien: setValidity() del tema hace
           target.value = target.defaultValue, y sin refrescarlo repondria la
           cantidad que imprimio Liquid al cargar la pagina. */
        input.defaultValue = String(qty);
      }
      recalcularLinea(row);
    }
    return row;
  }

  /* Fallo de TRANSPORTE: el servidor no llego a contestar nada util. Aqui SI
     corresponde un aviso propio, porque "intenta de nuevo" es verdad. */
  function revertirLinea(linea, status) {
    var row = devolverFilaAlUltimoValorConfirmado(linea);
    avisar(row, status === 429 ? TEXTO_RITMO : TEXTO_FALLO);
  }

  /* ---------------- parche de los prototipos de cart.js ---------------- */
  var enVuelo = {};     /* linea -> true mientras hay una peticion viva */
  var pendiente = {};   /* linea -> ultimo valor pedido durante esa peticion */

  /* ==========================================================================
     LA CONDICION ESTA INVERTIDA A PROPOSITO

     El comportamiento POR DEFECTO es el del tema: repintar. El atajo sin
     repintado hay que GANARSELO. La forma contraria -- ir anadiendo "si es
     esto, repinta" -- ya fallo DOS veces en un mismo dia: primero con el
     rechazo por existencias y despues con el bote de basura, que dejaba la fila
     en pantalla porque el innerHTML que la borraba era justo el que se habia
     quitado. Una lista de excepciones siempre se queda corta.

     Devuelve null si el atajo es seguro, o el MOTIVO por el que no lo es.

     (c) NO ES PARANOIA. Esta medido en este proyecto que /cart.js se
     desincronizo un 35% en 6 segundos porque Shopify RECORTO el carrito por
     inventario despues de servir la pagina. Una linea puede desaparecer sin que
     nadie la haya eliminado, y entonces hay que repintar aunque el clic fuera un
     "+" inocente. Por eso se comparan IDENTIDADES de linea, nunca indices: el
     envoltorio de regalo, ademas, lo mueve Liquid al final de la tabla, asi que
     el orden del DOM y el de cart.items no tienen por que coincidir.
     ========================================================================== */
  function porQueNoSePuedeEnSitio(cart, linea) {
    if (!cart || Object.prototype.toString.call(cart.items) !== '[object Array]') return 'la respuesta no trae items';

    var filas = document.querySelectorAll('main-cart .cart-quote__row');
    if (filas.length !== cart.items.length) {
      return 'cambio el numero de lineas (' + filas.length + ' -> ' + cart.items.length + ')';
    }

    var tocada = document.getElementById('CartItem-' + linea);
    if (!tocada) return 'no encuentro la fila ' + linea;
    var variTocada = tocada.getAttribute('data-variant-id');

    /* Cantidades por variante a los dos lados. En la fila tocada el atributo
       data-quantity ya viene pisado por el listener de 'change' con el valor
       optimista, asi que para ESA se usa la ultima cantidad confirmada. */
    var enDom = {}, enCarrito = {}, i, k;
    for (i = 0; i < filas.length; i++) {
      var vid = filas[i].getAttribute('data-variant-id') || ('sin-variante-' + i);
      var q = (filas[i] === tocada && isFinite(filas[i].__mahaQtyServidor))
        ? filas[i].__mahaQtyServidor
        : parseInt(filas[i].getAttribute('data-quantity'), 10);
      if (!isFinite(q)) return 'no puedo leer la cantidad de una fila';
      enDom[vid] = (enDom[vid] || 0) + q;
      /* Identidad fuerte cuando la tenemos: la clave de linea que guardo
         aplicarEnSitio la ultima vez. */
      if (filas[i].__mahaKey) {
        var sigue = false;
        for (k = 0; k < cart.items.length; k++) if (cart.items[k].key === filas[i].__mahaKey) { sigue = true; break; }
        if (!sigue) return 'desaparecio la clave de linea ' + filas[i].__mahaKey;
      }
    }
    for (i = 0; i < cart.items.length; i++) {
      var v2 = String(cart.items[i].variant_id);
      enCarrito[v2] = (enCarrito[v2] || 0) + cart.items[i].quantity;
    }

    /* (c) ninguna variante entra ni sale; (d) solo cambia la cantidad de la tocada */
    for (k in enDom) if (Object.prototype.hasOwnProperty.call(enDom, k)) {
      if (!Object.prototype.hasOwnProperty.call(enCarrito, k)) return 'desaparecio la variante ' + k;
      if (enCarrito[k] !== enDom[k] && k !== variTocada) return 'cambio la cantidad de otra linea (' + k + ')';
    }
    for (k in enCarrito) if (Object.prototype.hasOwnProperty.call(enCarrito, k)) {
      if (!Object.prototype.hasOwnProperty.call(enDom, k)) return 'aparecio una variante nueva (' + k + ')';
    }

    var suma = 0;
    for (i = 0; i < cart.items.length; i++) suma += cart.items[i].quantity;
    if (cart.item_count !== suma) return 'item_count no cuadra con la suma de lineas';
    if (cart.item_count === 0) return 'el carrito quedo vacio';

    return null;
  }

  /* ==========================================================================
     CARRITO-CART-CHANGE-URL-JS  ·  2026-08-24

     LO QUE SE CREYO PRIMERO Y RESULTO INCOMPLETO -- dejarlo escrito para que
     nadie repita la misma pista falsa: snippets/js-variables.liquid definia
     cart_add_url/cart_change_url/cart_update_url SIN `| append: '.js'`, y la
     hipotesis inicial fue que ESO causaba `sections: null` en la respuesta
     de /cart/change. Se corrigio el .js (sigue corregido: es el uso correcto
     documentado por Shopify y coincide con un respaldo forense de un tema
     anterior de esta tienda) -- pero PROBADO EN VIVO tras el arreglo, en el
     PREVIEW del tema de trabajo (?preview_theme_id=...), `sections` SEGUIA
     llegando null con .js Y SIN .js por igual, tanto en formato array como
     string. Se aislo la variable real: la MISMA peticion (.js, array,
     seccion identica) contra el sitio PUBLICADO (maha.com.mx, sin
     preview_theme_id) SI devuelve `sections` correctamente -- con o sin
     .js. Y un borrado real con clic, en el carrito real de maha.com.mx, se
     completo en 786ms sin ningun error de consola.

     CAUSA RAIZ REAL: el modo de vista previa de temas de Shopify
     (?preview_theme_id=) no devuelve `sections` en las respuestas de
     /cart/change|add|update.js -- una limitacion de la plataforma, no un
     bug de este tema, y no arreglable desde Liquid ni desde JS. En
     PRODUCCION (el tema publicado) nunca ha estado roto: medido hoy con un
     clic real. El .js se conserva de todas formas porque es la convencion
     correcta y no hace dano, pero NO es la causa raiz de la ruedita eterna.

     cart.js:200 SIGUE haciendo `event.cart.sections[sectionId]` SIN GUARDIA
     -- con sections null (como pasa SIEMPRE en preview) eso lanza
     TypeError, la excepcion muere en un catch mudo (console.log), y la fila
     se queda con la ruedita para siempre CADA VEZ que alguien revisa el
     borrador via el boton "Vista previa" de Shopify -- que es exactamente
     como se prueba un tema antes de publicarlo. Ese es el impacto real:
     nadie puede revisar el borrado (ni el cupon, ni el envoltorio, que
     comparten el mismo onCartUpdate) en la vista previa del tema de
     trabajo. Lo de aqui abajo hace que esa vista previa termine SIEMPRE en
     un estado visible (recarga) en vez de una ruedita eterna, y de paso
     cierra el vuelo-doble del bote de basura, que no tenia NINGUN control.

     QUE CAMBIA EN ESTE ARCHIVO:
       1. updateQuantity gana una tercera rama (ademas del stepper y del
          "todo lo demas al original"): cantidad === 0, o sea el bote de
          basura. Vuelo unico por linea (mismo mapa `enVuelo` que ya usaba
          el stepper), hideLoader GARANTIZADO en un finally, y un catch que
          avisa en la fila en vez de callarse. Sigue pidiendo `sections` y
          sigue publicando SIN __mahaStepper: el borrado NO se convierte en
          actualizacion en sitio (ver el bloque de arriba, que ya explica
          por que: cupon, envio, envoltorio, bundles y los recortes de
          inventario de Shopify dependen del repintado completo).
       2. onCartUpdate gana una rama para TODO evento que no sea el stepper
          y no sea un error de Shopify: conserva scrollY de la ventana y el
          scrollTop de .cart-quote__table-scroll ANTES del repintado
          original, y los repone justo despues, en el mismo tick de JS,
          antes de que el navegador pinte nada. Si `sections` sigue
          llegando null pese al arreglo de arriba, o si el repintado
          original lanza cualquier otra excepcion, se recarga /cart -- igual
          que ya hacia porQueNoSePuedeEnSitio para el stepper. Nunca se
          queda la ruedita.
     ========================================================================== */

  /* ---------------- borrar una linea (bote de basura) ----------------
     NO reusa el mapa `pendiente` del stepper a proposito: mas abajo en este
     mismo archivo (CARRITO-COLUMNA-SKU-AJUSTADA) hay un `var pendiente = null`
     al mismo nivel de la IIFE que lo pisaria. Aqui no hace falta cola: un
     segundo clic mientras la linea ya vuela simplemente SE IGNORA (1.4 --
     "el bote de esa fila no acepta otro clic"), no se reintenta con el
     ultimo valor porque solo hay un valor posible (borrar).

     Sigue pidiendo `sections` -- igual que el original -- y publica SIN
     __mahaStepper: el repintado completo lo hace onCartUpdate mas abajo, con
     la posicion conservada. Este bloque no repinta nada por su cuenta. */
  function borrarLinea(instancia, line, quantity, name, target) {
    if (enVuelo[line]) return;   // 2.4: un solo vuelo por linea
    enVuelo[line] = true;
    instancia.showLoader(line);

    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );
    var config = FoxTheme.utils.fetchConfig();
    var opciones = {
      method: config.method,
      headers: config.headers,
      body: JSON.stringify({ line: line, quantity: 0, sections: sectionsToBundle }),
    };

    fetch(FoxTheme.routes.cart_change_url, opciones)
      .then(function (r) {
        return r.json().then(function (json) { return { ok: r.ok, json: json }; });
      })
      .then(function (res) {
        if (!res.ok || !res.json || Object.prototype.toString.call(res.json.items) !== '[object Array]') {
          throw new Error('respuesta invalida al borrar (status ' + (res.json && res.json.status) + ')');
        }
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          cart: res.json, target: target, line: line, name: name,
        });
      })
      .catch(function (err) {
        /* 2.3: el catch deja de ser console.log y listo. No hay optimista
           que revertir (nada se quito del DOM todavia), asi que "restaurar"
           aqui es simplemente avisar EN LA FILA -- la ruedita la apaga el
           finally de abajo, siempre, pase lo que pase. */
        avisar(document.getElementById('CartItem-' + line), 'No se pudo eliminar. Intenta de nuevo.');
        if (window.console && console.warn) console.warn('[MAHA carrito] fallo al borrar la linea ' + line + ': ' + (err && err.message));
      })
      .finally(function () {
        // 2.2: SIEMPRE, exito o fallo -- nunca depende de que un repintado
        // futuro destruya el nodo de la ruedita.
        enVuelo[line] = false;
        instancia.hideLoader(line);
      });
  }

  function parchearCartItems() {
    var C = window.customElements && customElements.get('cart-items');
    if (!C || C.prototype.__mahaSinSalto) return false;
    var proto = C.prototype;
    var updateQuantityOriginal = proto.updateQuantity;
    var onCartUpdateOriginal = proto.onCartUpdate;

    /* 1. SIN paquete `sections` -- pero SOLO para el stepper +/- de una linea.
          Todo lo demas se va al original, que si pide `sections` y si repinta.

          EL BOTE DE BASURA ENTRA POR AQUI MISMO: cart.js:327 hace
          updateQuantity(index, 0) SIN `name` y SIN `target`. Exigir que el
          target sea el input del stepper de una linea, y cantidad > 0, lo deja
          fuera sin necesidad de nombrarlo -- y deja fuera tambien a cualquier
          futuro llamador que no sea el stepper, que es justo lo que fallaba al
          mantener una lista de excepciones.

          Esta guarda es ademas OBLIGATORIA por seguridad: si dejaramos pasar una
          mutacion que luego no podemos aplicar en sitio, el original recibiria
          una respuesta SIN `sections` y su parseFromString(undefined) acabaria
          en mainCart.remove() -- el carrito entero en blanco. */
    proto.updateQuantity = function (line, quantity, name, target) {
      if (!esCarritoDePagina(this)) return updateQuantityOriginal.apply(this, arguments);
      var cantidad = parseInt(quantity, 10);
      var vieneDelStepper = !!(target && target.classList && target.classList.contains('quantity__input') &&
        target.closest && target.closest('[data-mayoreo-line]') && target.closest('main-cart'));

      if (!vieneDelStepper && isFinite(cantidad) && cantidad === 0) {
        return borrarLinea(this, line, quantity, name, target);
      }

      if (!vieneDelStepper || !isFinite(cantidad) || cantidad <= 0) {
        return updateQuantityOriginal.apply(this, arguments);
      }
      var self = this;

      /* Clics rapidos: si esa linea ya tiene una peticion viva, no se lanza otra.
         Se guarda el ultimo valor y se manda al volver. Cinco + seguidos salen
         como una peticion (o dos, si el primer clic llego antes que el resto). */
      if (enVuelo[line]) { pendiente[line] = { quantity: quantity, name: name, target: target }; return; }
      enVuelo[line] = true;
      atenuarFila(line);

      var config = FoxTheme.utils.fetchConfig();
      var opciones = { method: config.method, headers: config.headers, body: JSON.stringify({ line: line, quantity: quantity }) };

      fetch(FoxTheme.routes.cart_change_url, opciones)
        .then(function (r) {
          return r.text().then(function (t) {
            var json = null;
            try { json = JSON.parse(t); } catch (e) {}
            return { ok: r.ok, status: r.status, json: json, bytes: t.length };
          });
        })
        .then(function (res) {
          /* TRES desenlaces, no dos. Confundir el 2 con el 3 fue la regresion:
             un rechazo por existencias salia con el cuadro rojo de MAHA en vez
             del mensaje real de Shopify, que dice cuantas unidades quedan.

             EL DISCRIMINANTE ES EL CUERPO, NO EL STATUS -- los dos son 4xx:
               · rechazo de Shopify : 422 + application/json + {"errors":"..."}
                 (82 bytes, SIN items). Contesto la tienda, y con razon.
               · limitador / red    : 429 con cuerpo HTML, o fetch fallido.
                 No hay JSON de Shopify que creer. */
          var esCarrito = !!(res.json && Object.prototype.toString.call(res.json.items) === '[object Array]');
          var mensaje = null;
          if (res.json) {
            if (typeof res.json.errors === 'string') mensaje = res.json.errors;
            else if (typeof res.json.description === 'string') mensaje = res.json.description;
            else if (typeof res.json.message === 'string' && !esCarrito) mensaje = res.json.message;
          }

          /* Se descarta lo que hubiera en cola para esa linea: reintentarlo tras
             un rechazo seria pedir de nuevo lo que acaban de negar. */
          if (mensaje || !res.ok || !esCarrito) { quitarAtenuacion(line); delete pendiente[line]; }

          if (mensaje && !esCarrito) {
            /* 2. RECHAZO DE SHOPIFY -> via NATIVA. Se devuelve la fila a la
               ultima cantidad confirmada (el listener de 'change' ya habia
               pisado data-quantity) y se PUBLICA la respuesta tal cual: eso la
               lleva a onCartUpdate -> onCartError -> setValidity, que ensena el
               texto real de Shopify en la burbuja del navegador. SIN aviso
               propio: aqui "intenta de nuevo" mentiria. */
            devolverFilaAlUltimoValorConfirmado(line);
            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
              cart: res.json, target: target, line: line, name: name, __mahaStepper: true,
            });
            return;
          }
          if (!res.ok || !esCarrito) { revertirLinea(line, res.status); return; }
          if (mensaje) {
            /* Caso que hoy no se ha visto pero que el tema contempla: carrito
               COMPLETO y ademas un aviso. Los numeros ya son de fiar, asi que se
               pintan y el mensaje va por la via nativa. */
            aplicarEnSitio(res.json, line);
            if (target && typeof self.onCartError === 'function') self.onCartError(mensaje, target);
            return;
          }

          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
            cart: res.json, target: target, line: line, name: name, __mahaStepper: true,
          });
        })
        .catch(function () { quitarAtenuacion(line); delete pendiente[line]; revertirLinea(line, 0); })
        .then(function () {
          enVuelo[line] = false;
          var p = pendiente[line];
          if (p) { delete pendiente[line]; self.updateQuantity(line, p.quantity, p.name, p.target); }
        });
    };

    /* 2. El repintado del tema es LO NORMAL. El atajo SIN repintado (mas
          abajo, aplicarEnSitio) solo se toma si la mutacion se lo gano:
          viene del stepper (marca __mahaStepper) Y ademas el carrito
          devuelto sigue teniendo las mismas lineas. Cualquier otra cosa --
          el bote de basura, un cupon, bundles, el envoltorio de regalo, o
          un carrito que Shopify recorto por su cuenta -- sigue cayendo en
          el repintado completo, pero YA NO "intacto": desde 2026-08-24 pasa
          por la rama de abajo, que le conserva la posicion de scroll y le
          garantiza una salida visible aunque `sections` volviera a faltar. */
    proto.onCartUpdate = function (event) {
      if (!esCarritoDePagina(this)) return onCartUpdateOriginal.apply(this, arguments);

      /* Rechazo de Shopify (sin existencias): VA PRIMERO. Sin esta linea caeria
         en la guarda de abajo -- una respuesta {"errors":"..."} no trae items --
         y acabaria RECARGANDO la pagina en vez de ensenar el mensaje. El
         original hace justo lo que toca (onCartError -> setValidity) y devuelve
         antes de mirar `sections`, asi que delegarle es seguro. */
      if (event && event.cart && event.cart.errors) return onCartUpdateOriginal.apply(this, arguments);

      if (event && event.__mahaStepper) {
        var motivo = porQueNoSePuedeEnSitio(event.cart, event.line);
        if (motivo) {
          /* Se gano el atajo en la ida pero no en la vuelta: el carrito cambio de
             forma. NO se puede delegar en el original, porque esta respuesta no
             trae `sections` y su parseFromString(undefined) borraria <main-cart>.
             Se recarga /cart, que es lento pero siempre correcto. Solo puede pasar
             si el carrito se movio por debajo entre la peticion y la respuesta. */
          if (window.console && console.warn) console.warn('[MAHA carrito] recargo, no puedo actualizar en sitio: ' + motivo);
          window.location.assign(FoxTheme.routes.cart_url);
          return;
        }

        quitarAtenuacion(event.line);
        aplicarEnSitio(event.cart, event.line);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: event.cart } }));
        return;
      }

      /* CARRITO-CART-CHANGE-URL-JS: cualquier otro publicador de cartUpdate
         (borrado, cupon, envoltorio de regalo, o el original de cantidad si
         algun dia cayera aqui) SIGUE haciendo el repintado completo -- eso
         no cambia -- pero con dos garantias nuevas:

         (a) si `sections` no llego, NO se llama al original:
             parseFromString(undefined) lo destruiria todo, y esa es justo
             la ruedita eterna que se midio en el borrado. ESTO ES LO
             ESPERADO en la vista previa de un tema no publicado
             (?preview_theme_id=): Shopify no manda `sections` ahi, medido
             en vivo con y sin el ".js" de las rutas y en los dos formatos
             de `sections` (array/string) -- nunca llega, en ningun caso, en
             preview. En el sitio PUBLICADO si llega (probado con un
             borrado real en maha.com.mx: 786ms, sin error). Por eso el
             aviso de consola no manda a revisar el ".js" -- ya se
             comprobo que no es la causa -- y se recarga /cart, que en
             preview es la unica salida SIEMPRE visible.
         (b) si `sections` SI llego (el caso normal en produccion), se
             conserva la posicion de scroll (ventana Y el contenedor de la
             tabla) a traves del repintado: se captura ANTES, se llama al
             original (que reemplaza mainCart.innerHTML de una sola vez,
             sincrono), y se repone INMEDIATAMENTE despues, en el mismo
             tick de JS -- antes de que el navegador tenga oportunidad de
             pintar nada intermedio. La altura de <main-cart> se reserva
             mientras tanto (belt-and-braces, no sustituto de lo anterior:
             un innerHTML de un solo tiron no deberia dejar ver un estado
             intermedio, pero por si el navegador partiera el trabajo en
             HTML gigantes). */
      var seccionesFaltan = !(event && event.cart && event.cart.sections);
      if (seccionesFaltan) {
        if (window.console && console.warn) {
          console.warn('[MAHA carrito] recargo: el carrito no trajo `sections`. Normal en vista previa de un tema no publicado (limitacion de Shopify, no de este codigo); si esto pasa en el sitio PUBLICADO, es un problema real -- ver CARRITO-CART-CHANGE-URL-JS en este archivo.');
        }
        window.location.assign(FoxTheme.routes.cart_url);
        return;
      }

      var mainCartEl = this.closest('main-cart');
      var scroller = mainCartEl ? mainCartEl.querySelector('.cart-quote__table-scroll') : null;
      var winScrollY = window.scrollY;
      var contScrollTop = scroller ? scroller.scrollTop : null;
      if (mainCartEl) mainCartEl.style.minHeight = mainCartEl.offsetHeight + 'px';

      try {
        onCartUpdateOriginal.apply(this, arguments);
      } catch (err) {
        if (window.console && console.warn) console.warn('[MAHA carrito] recargo: fallo repintando el carrito: ' + (err && err.message));
        window.location.assign(FoxTheme.routes.cart_url);
        return;
      } finally {
        if (mainCartEl) mainCartEl.style.minHeight = '';
      }

      var mainCartNuevo = document.querySelector('main-cart');
      var scrollerNuevo = mainCartNuevo ? mainCartNuevo.querySelector('.cart-quote__table-scroll') : null;
      if (scrollerNuevo && contScrollTop != null) scrollerNuevo.scrollTop = contScrollTop;
      window.scrollTo(0, winScrollY);
    };

    proto.__mahaSinSalto = true;
    return true;
  }

  /* El tema se suscribe con this.onCartUpdate.bind(this) DENTRO del constructor,
     y eso resuelve el metodo del prototipo EN ESE MOMENTO. cart.js corre antes
     que este archivo, asi que la instancia viva quedo atada a la version sin
     parchear y parchear el prototipo no la alcanzaria. Se deshace su suscripcion
     con el desuscriptor que el propio tema expone (cartUpdateUnsubscriber, el
     mismo que usa su disconnectedCallback) y se vuelve a suscribir con una
     resolucion TARDIA, que si ve el parche. */
  function reengancharInstancias() {
    if (!window.FoxTheme || !FoxTheme.pubsub) return;
    var lista = document.querySelectorAll('cart-items');
    for (var i = 0; i < lista.length; i++) {
      var ci = lista[i];
      if (ci.__mahaReenganchado) continue;
      if (!esCarritoDePagina(ci)) continue;
      if (typeof ci.cartUpdateUnsubscriber !== 'function') continue;
      ci.cartUpdateUnsubscriber();
      ci.cartUpdateUnsubscriber = (function (el) {
        return FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (ev) {
          el.onCartUpdate(ev);
        });
      })(ci);
      ci.__mahaReenganchado = true;
    }
  }

  function arrancarSinSalto() {
    if (!window.FoxTheme || !FoxTheme.routes || !window.customElements) return;
    if (!document.querySelector('main-cart')) return;   /* solo /cart */
    if (!parchearCartItems() && !document.querySelector('cart-items')) return;
    reengancharInstancias();
    /* La cantidad confirmada por el servidor arranca en la que imprimio Liquid.
       De ella se revierte cuando una peticion falla. */
    var filas = lineRows(document);
    for (var i = 0; i < filas.length; i++) {
      filas[i].__mahaQtyServidor = parseInt(filas[i].getAttribute('data-quantity'), 10);
    }
    /* Si el tema llegara a repintar por otra via (borrar una linea), nacen
       <cart-items> nuevos: hay que volver a engancharlos. */
    document.addEventListener('cart:updated', reengancharInstancias);
  }

  function start() {
    /* CARRITO-ACTUALIZACION-SIN-SALTO: va PRIMERO para que los prototipos de
       cart.js queden parcheados antes de que nada pueda disparar un cambio. */
    arrancarSinSalto();
    refreshAll(document);
    /* eventos reales del tema: Section Rendering ya reemplazó el HTML del
       carrito para este punto, así que una relectura del DOM basta (sin
       MutationObserver: cada carga es idempotente, no hay filas que duplicar) */
    document.addEventListener('cart:updated', function () { refreshAll(document); });
    document.addEventListener('cart:refresh', function () { refreshAll(document); });
    /* cart:shipping-applied (COTIZACION-AJUSTE-COLUMNAS-Y-GRIS 2026-08-24):
       lo dispara aplicarTarifa() en sections/main-cart.liquid. Recalcula
       SOLO el resumen (updateSummary), sin refreshAll -- aplicar una
       tarifa no cambia ningun tramo de mayoreo, asi que no hace falta
       volver a pedirlos a HulkApps. */
    document.addEventListener('cart:shipping-applied', function () { updateSummary(document); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();


/* ============================================================================
   CARRITO-COLUMNA-SKU-AJUSTADA   2026-08-17
   Mide el SKU mas ancho de ESTE carrito y fija --maha-sku-w / --maha-prod-w.

   POR QUE VIVE AQUI Y NO EN sections/main-cart.liquid: ese archivo lo esta
   editando otra sesion en paralelo y cada PUT es un riesgo de choque. Este
   asset ya lo carga /cart, ya escucha cart:updated y cart:refresh, y es de
   MAHA. Asi el cambio no toca ningun archivo en disputa.

   Se MIDE EL TEXTO RENDERIZADO con un <span> fuera de pantalla que copia la
   tipografia real de la celda. No se cuentan caracteres: los ~7.4px por
   caracter son un promedio y un SKU con mayusculas o espacios se desvia.
   ============================================================================ */
(function () {
  'use strict';
  if (window.__mahaSkuFitInit) return;
  window.__mahaSkuFitInit = true;

  var TOPE = 150, PISO = 56, BASE_SKU = 160, BASE_PROD = 176;
  var SUMA = BASE_SKU + BASE_PROD;               // 336: lo que se reparten las dos
  var sonda = null;

  function anchoDeTexto(texto, cs) {
    if (!sonda) {
      sonda = document.createElement('span');
      sonda.setAttribute('aria-hidden', 'true');
      sonda.style.cssText = 'position:absolute;left:-9999px;top:-9999px;visibility:hidden;' +
        'white-space:nowrap;pointer-events:none';
      document.body.appendChild(sonda);
    }
    sonda.style.font = cs.font;
    sonda.style.letterSpacing = cs.letterSpacing;
    sonda.style.textTransform = cs.textTransform;
    sonda.textContent = texto;
    return sonda.getBoundingClientRect().width;
  }
  function padH(el) {
    var cs = getComputedStyle(el);
    return parseFloat(cs.paddingLeft || 0) + parseFloat(cs.paddingRight || 0);
  }

  function ajustar() {
    var tabla = document.querySelector('.cart-quote.cart-table-fix .cart-quote__table');
    if (!tabla) return;

    // Fuera de escritorio no se toca nada: el carrito movil se rehace aparte.
    if (!window.matchMedia('(min-width: 1024px)').matches) {
      tabla.style.removeProperty('--maha-sku-w');
      tabla.style.removeProperty('--maha-prod-w');
      tabla.removeAttribute('data-maha-sku-fit');
      return;
    }
    var celdas = tabla.querySelectorAll('tbody .cart-quote__sku');
    if (!celdas.length) return;

    var max = 0;
    var csCelda = getComputedStyle(celdas[0]);
    for (var i = 0; i < celdas.length; i++) {
      var t = (celdas[i].textContent || '').trim();
      if (t) max = Math.max(max, anchoDeTexto(t, csCelda));
    }
    var td = celdas[0].closest('td');
    var necesario = max + (td ? padH(td) : 16);

    // el encabezado tambien tiene que caber
    var th = tabla.querySelectorAll('thead th')[1];
    if (th) necesario = Math.max(necesario, anchoDeTexto((th.textContent || '').trim(), getComputedStyle(th)) + padH(th));

    var ancho = Math.ceil(necesario);
    var cabe = ancho <= TOPE;
    if (ancho > TOPE) ancho = TOPE;
    if (ancho < PISO) ancho = PISO;

    tabla.style.setProperty('--maha-sku-w', ancho + 'px');
    tabla.style.setProperty('--maha-prod-w', (SUMA - ancho) + 'px');   // la suma sigue dando 1160
    tabla.setAttribute('data-maha-sku-fit', cabe ? '1' : '0');
  }

  var pendiente = null;
  function programar() {
    if (pendiente) cancelAnimationFrame(pendiente);
    pendiente = requestAnimationFrame(function () { pendiente = null; ajustar(); });
  }

  function arrancar() {
    ajustar();
    ['cart:updated', 'cart:refresh', 'cart:grouped-sections'].forEach(function (ev) {
      document.addEventListener(ev, programar);
    });
    window.addEventListener('resize', programar);
    // red de seguridad: el tema repinta el tbody sin avisar por evento
    var cont = document.querySelector('.cart-quote.cart-table-fix .cart-quote__table tbody');
    if (cont && window.MutationObserver) {
      new MutationObserver(programar).observe(cont, { childList: true, subtree: true, characterData: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})();
/* === /CARRITO-COLUMNA-SKU-AJUSTADA === */

/* ============================================================================
   MAHA-AGREGAR-OPTIMISTA   2026-08-20
   Abre el cajon y pinta la linea nueva EN EL MISMO FRAME DEL CLIC, sin esperar
   a la red. Antes: dos viajes secuenciales -- POST /cart/add.js y luego GET
   /cart.js -- antes de que showCartDrawer() corriera. Ahora: el cajon se abre
   de inmediato con una fila PROVISIONAL (foto, titulo, cantidad, precio que la
   propia tarjeta ya conoce), y se hace UN SOLO fetch a /cart/add.js (con
   `sections`, que el propio tema ya arma via el evento 'cart:grouped-sections'
   antes de llegar aqui). Al responder, la fila provisional se reemplaza por la
   real, sacada del HTML de `sections` -- el GET a /cart.js que solo servia
   para el total del carrito queda eliminado: item_count y subtotal se derivan
   leyendo ese mismo HTML (sumando data-quantity de cada linea y leyendo
   data-cart-subtotal-cents), no de una segunda peticion ni de una cifra
   inventada.

   POR QUE EN ESTE ARCHIVO Y NO EN theme.js: ProductForm.handleFormSubmission
   y ProductForm.showCartDrawer son class fields de funcion flecha
   ( = (config) => {...} ), es decir, propiedad PROPIA de cada instancia desde
   que se construye. Parchear ProductForm.prototype.handleFormSubmission NO
   surtiria ningun efecto -- ni en instancias existentes ni en futuras, porque
   la busqueda de `this.handleFormSubmission` siempre encuentra primero la
   propiedad de la instancia. Este archivo carga despues de theme.js (defer,
   orden de documento) y sobreescribe esa propiedad EN CADA INSTANCIA
   directamente, que si funciona. Un MutationObserver cubre los formularios
   insertados despues (recomendaciones del cajon, secciones recargadas via
   AJAX), y un listener de 'submit' en fase de CAPTURA en document es la red de
   seguridad para el formulario que se envia ANTES de que el observer/escaneo
   inicial llegue a el.

   SI ALGO INESPERADO PASA (estructura de tarjeta distinta, campo ausente en la
   respuesta), el codigo cae de vuelta al handleFormSubmission ORIGINAL
   guardado -- nunca deja el envio a medias.

   RIESGO CONOCIDO Y NO RESUELTO HOY: el objeto `cart` que se publica en
   cart:updated / pubsub cartUpdate se sintetiza a partir del HTML de
   `sections` (item_count contado, subtotal leido de data-cart-subtotal-cents),
   no es el objeto completo que devuelve GET /cart.js. Si alguno de los otros
   8 suscriptores de cartUpdate lee un campo que no esta aqui (p.ej.
   cart.items completo), fallara en silencio para ESE suscriptor -- no se pudo
   verificar uno por uno hoy. Revisar consola en la verificacion.
   ============================================================================ */
(function () {
  'use strict';
  if (window.__mahaAgregarOptimistaInit) return;
  window.__mahaAgregarOptimistaInit = true;

  function getSectionId(el) {
    try {
      if (window.FoxTheme && FoxTheme.utils && typeof FoxTheme.utils.getSectionId === 'function') {
        return FoxTheme.utils.getSectionId(el);
      }
    } catch (e) {}
    var closest = el.closest('[data-section-id]');
    return closest ? closest.getAttribute('data-section-id') : null;
  }

  function extraerDatosTarjeta(form) {
    var tarjeta = form.closest('.product-card, [class*="product-card"]') || form;
    var img = tarjeta.querySelector('img');
    var titulo = tarjeta.querySelector('[class*="title"]');
    var precio = tarjeta.querySelector('[class*="price"]');
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    return {
      variantId: idInput ? idInput.value : null,
      quantity: qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1,
      imgSrc: img ? (img.currentSrc || img.src) : '',
      imgAlt: img ? (img.alt || '') : '',
      titulo: titulo ? titulo.textContent.trim() : '',
      precioTexto: precio ? precio.textContent.trim() : '',
    };
  }

  function construirFilaOptimista(datos) {
    var li = document.createElement('li');
    li.className = 'cart-item flex flex-col maha-optimista';
    li.setAttribute('data-variant-id', datos.variantId || '');
    li.setAttribute('data-quantity', String(datos.quantity));
    li.setAttribute('data-maha-optimista', 'true');
    li.style.opacity = '0.55';
    li.innerHTML =
      '<div class="cart-item__product flex items-start gap-3">' +
        (datos.imgSrc ? '<img src="' + datos.imgSrc.replace(/"/g, '&quot;') + '" alt="' + datos.imgAlt.replace(/"/g, '&quot;') + '" style="width:64px;height:64px;object-fit:cover;border-radius:4px;">' : '') +
        '<div class="cart-item__details flex-grow flex flex-col gap-3">' +
          '<div class="block">' + (datos.titulo || '') + '</div>' +
          '<div class="maha-optimista__nota" style="font-size:.85em;opacity:.8;">Agregando&hellip; &times; ' + datos.quantity + '</div>' +
          '<div>' + (datos.precioTexto || '') + '</div>' +
        '</div>' +
      '</div>';
    return li;
  }

  function sumarItemCount(bodyParsedRoot) {
    var filas = bodyParsedRoot.querySelectorAll('[data-quantity]');
    var total = 0;
    for (var i = 0; i < filas.length; i++) {
      var q = parseInt(filas[i].getAttribute('data-quantity'), 10);
      if (!isNaN(q)) total += q;
    }
    return total;
  }

  function aplicarRespuestaReal(form, cartDrawerEl, sectionId, datos, parsedState) {
    var html = parsedState && parsedState.sections ? parsedState.sections[sectionId] : null;
    if (!html) throw new Error('sections[' + sectionId + '] ausente en la respuesta de /cart/add.js');

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var bodyNuevo = doc.querySelector('#CartDrawerBody-' + sectionId) || doc.querySelector('[id^="CartDrawerBody-"]');
    if (!bodyNuevo) throw new Error('CartDrawerBody ausente en el HTML de sections');

    var bodyVivo = document.querySelector('#CartDrawerBody-' + sectionId) || document.querySelector('[id^="CartDrawerBody-"]');
    var placeholder = bodyVivo ? bodyVivo.querySelector('[data-maha-optimista="true"]') : null;

    var filaReal = bodyNuevo.querySelector('[data-variant-id="' + datos.variantId + '"]');
    if (placeholder) {
      if (filaReal) {
        placeholder.replaceWith(document.importNode(filaReal, true));
      } else {
        placeholder.remove();
      }
    }

    // Importes: subtotal desde el propio HTML de sections (no inventado, no de /cart.js)
    var subtotalNuevoEl = doc.querySelector('.totals__subtotal-value[data-cart-subtotal-cents]');
    var subtotalVivoEl = document.querySelector('.totals__subtotal-value[data-cart-subtotal-cents]');
    if (subtotalNuevoEl && subtotalVivoEl) {
      subtotalVivoEl.setAttribute('data-cart-subtotal-cents', subtotalNuevoEl.getAttribute('data-cart-subtotal-cents'));
      subtotalVivoEl.textContent = subtotalNuevoEl.textContent;
    }

    var itemCount = sumarItemCount(bodyNuevo);
    var cartSintetico = {
      item_count: itemCount,
      sections: parsedState.sections,
    };
    if (subtotalNuevoEl) {
      var cents = parseInt(subtotalNuevoEl.getAttribute('data-cart-subtotal-cents'), 10);
      if (!isNaN(cents)) cartSintetico.total_price = cents;
    }

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartSintetico } }));
    try {
      if (window.FoxTheme && FoxTheme.pubsub) {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartSintetico });
      }
    } catch (e) {}

    if (cartDrawerEl) {
      cartDrawerEl.classList.remove('hidden');
      var empty = document.querySelector('[id^="CartDrawerEmpty-"]');
      var footer = document.querySelector('[id^="CartDrawerFooter-"]');
      if (bodyVivo) bodyVivo.classList.remove('hidden');
      if (footer) footer.classList.remove('hidden');
      if (empty) empty.classList.add('hidden');
    }
  }

  /* PDP-MENSAJE-STOCK 2026-08-21 -- revertirOptimista() hacia DOS cosas
     independientes: quitar la fila provisional del cajon y pintar un aviso
     propio. Aqui se SEPARAN sin cambiar ni una linea de ninguna de las dos.

     POR QUE: en el camino de "la tienda contesto con description" (mas abajo)
     se llamaba a esta funcion Y ADEMAS a form.handleCartError(), que pinta el
     aviso NATIVO del tema (.product-form__error-message). Resultado: dos nodos
     con el MISMO texto apilados en la PDP. Medido el 2026-08-21 sobre
     EFREF2X4E (inventario 2): 2 visibles durante los primeros ~6 s, y despues
     uno se apagaba solo por el setTimeout de aqui abajo mientras el otro se
     quedaba pegado para siempre.

     La reversion se conserva INTEGRA y se sigue llamando en los tres caminos.
     El aviso propio TAMBIEN se conserva, porque los dos caminos de RED de mas
     abajo (429 y fetch fallido) no llaman a handleCartError: sin el no se
     veria nada. */
  function quitarFilaOptimista() {
    var placeholder = document.querySelector('[data-maha-optimista="true"]');
    if (placeholder) placeholder.remove();
  }

  /* CORREGIDO 2026-08-24: tenia el MISMO bug de cierre que datosParaAviso()
     (ver ENMIENDA 3 mas abajo) -- form.closest('.product-card,
     [class*="product-card"]') devolvia el propio <form> en las tarjetas
     (su clase "product-card-v2__form" casa por subcadena). Ahora usa
     raizDelFormulario(), el mismo resolutor ya corregido y probado. */
  function avisarEnTarjeta(form, mensaje) {
    if (!mensaje) mensaje = 'No se pudo agregar. Intenta de nuevo.';
    var tarjeta = raizDelFormulario(form);
    if (tarjeta === document) tarjeta = form;
    var aviso = tarjeta.querySelector('.maha-agregar-error');
    if (!aviso) {
      aviso = document.createElement('div');
      aviso.className = 'maha-agregar-error';
      aviso.setAttribute('role', 'alert');
      aviso.style.cssText = 'color:#b00020;font-size:.85em;margin-top:4px;';
      (form.parentElement || tarjeta).appendChild(aviso);
    }
    aviso.textContent = mensaje;
    aviso.hidden = false;
    clearTimeout(aviso.__mahaTimer);
    aviso.__mahaTimer = setTimeout(function () { aviso.hidden = true; }, 6000);
  }

  /* Se conserva con la MISMA firma y el MISMO efecto, para los dos caminos de
     red de mas abajo, que no han cambiado. */
  function revertirOptimista(form, mensaje) {
    quitarFilaOptimista();
    avisarEnTarjeta(form, mensaje);
  }

  /* ==========================================================================
     CARRITO-AVISO — camino de agregar, 2026-08-21

     LA TESIS: el coste se mueve de la accion FRECUENTE a la RARA.
       Hoy   -> cada "Agregar" pide el cajon entero: 30.0 KB con 1 linea y
                393.9 KB con 50 (el cajon es el 89 % y el 99 %, crece x14.6).
       Ahora -> "Agregar" pide solo cart-aviso-totales (decenas de bytes, no
                crece con el carrito) y muestra una confirmacion. El cajon se
                refresca cuando alguien lo abre a proposito.

     EL CAJON NO PUEDE QUEDAR OBSOLETO: al agregar se marca sucio, y al pulsar
     el icono se refresca ANTES de abrirlo, reusando la puerta que ya existe
     (cart:refresh -> CartDrawer.onCartRefresh, assets/cart.js:42-64). Esa
     funcion NO se toca. Un cajon viejo seria peor que un cajon lento.
     ========================================================================== */

  function avisoActivo() {
    return !!(document.getElementById('MahaAviso') && window.MahaAviso);
  }

  function contadorActual() {
    var el = document.querySelector('[data-maha-cart-count]');
    if (!el) return null;
    var n = parseInt(el.getAttribute('data-maha-cart-count'), 10);
    return isFinite(n) ? n : null;
  }

  function contadorDeSecciones(parsedState) {
    var html = parsedState && parsedState.sections && parsedState.sections['cart-aviso-totales'];
    if (!html) return null;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector('[data-maha-cart-count]');
    if (!el) return null;
    var n = parseInt(el.getAttribute('data-maha-cart-count'), 10);
    return isFinite(n) ? n : null;
  }

  /* El contador del icono se actualiza llamando al propio <cart-count>, NO
     publicando cartUpdate. Motivo: CartItems.onCartUpdate (assets/cart.js:200)
     hace event.cart.sections[sectionId] SIN GUARDIA, asi que un evento sin
     `sections` lanzaria TypeError en cualquier pagina con cajon. */
  function actualizarContadorIcono(n) {
    if (!(n >= 0)) return;
    var el = document.querySelector('[data-maha-cart-count]');
    if (el) el.setAttribute('data-maha-cart-count', String(n));
    var contadores = document.querySelectorAll('cart-count');
    for (var i = 0; i < contadores.length; i++) {
      var c = contadores[i];
      if (typeof c.onCartUpdate === 'function') {
        try { c.onCartUpdate({ cart: { item_count: n } }); } catch (e) {}
      }
    }
  }

  function marcarCajonSucio() {
    var d = document.querySelector('cart-drawer');
    if (d) d.setAttribute('data-maha-cajon-sucio', '1');
  }

  /* ==========================================================================
     ENMIENDA 3, 2026-08-24 -- LA RAIZ ES LA TARJETA PULSADA, NUNCA UN GLOBAL.

     CAUSA REAL del bug reportado por el dueno (HOME sin foto/nombre/variante,
     PDP bien): la version anterior usaba
       form.closest('.product-card, [class*="product-card"]')
     closest() empieza a comparar por el PROPIO elemento antes de subir. El
     <form> de card-product-v2.liquid lleva class="product-card-v2__form", que
     CASA con [class*="product-card"] por subcadena -- "product-card-v2__form"
     contiene literalmente "product-card". Resultado: closest() devolvia el
     FORMULARIO MISMO, no la tarjeta. Con raiz = <form>, todo querySelector
     posterior buscaba SOLO dentro del form (que no tiene titulo ni imagen,
     solo el input oculto y el boton) y volvia vacio siempre. Confirmado
     leyendo snippets/card-product.liquid (form class="product-card__actions
     product-card__main-actions", MISMA trampa) y card-product-v2.liquid.

     El arreglo usa SELECTORES DE CLASE EXACTOS. closest('.product-card')
     empareja por TOKEN de classList (equivalente a classList.contains), NO
     por subcadena: "product-card-v2__form" no es el token exacto
     "product-card-v2" ni "product-card", asi que el form deja de emparejarse
     a si mismo y closest() sigue subiendo hasta el <article>/<div> real.
     card-product-list.liquid es el unico sin clase de raiz fija propia (la
     decide quien la incluye) -- lleva [data-maha-card-root] agregado hoy. */
  var SELECTOR_RAIZ_TARJETA = '[data-maha-card-root], .product-card-v2, .product-card--overlay, .product-card';

  function raizDelFormulario(form) {
    if (!form || !form.closest) return document;
    return form.closest('product-info') || form.closest(SELECTOR_RAIZ_TARJETA) || document;
  }

  /* ENMIENDA 2, 2026-08-24 -- LA FOTO, POR IDENTIDAD, NUNCA POR POSICION.

     media-gallery.js (PDP) inicializa Swiper con loop:true, que CLONA la
     ultima foto y la ANTEPONE al DOM: "el primer <img>" pasa a ser ese clon.
     El propio media-gallery.js YA distingue los clones con el filtro
     :not(.swiper-slide-duplicate) (linea 168) -- Swiper anota sus clones con
     esa clase el mismo, es su convencion, no una inventada aqui. Se reusa el
     mismo filtro. Si se conoce el id de medio (data-media-id, el que usa
     media-gallery.js:385 para emparejar variant.featured_media.id) se prueba
     primero por ese id exacto; si no, se cae al primer medio REAL (no clon).
     Las tarjetas no tienen Swiper, asi que aqui esto solo blinda la PDP sin
     variante en el JSON (unless product.has_only_default_variant la omite). */
  function fotoDeRaiz(raiz, mediaId) {
    if (!raiz) return '';
    var el = null;
    if (mediaId) el = raiz.querySelector('[data-media-id="' + mediaId + '"] img');
    if (!el) el = raiz.querySelector('.product__media-item:not(.swiper-slide-duplicate) img');
    if (!el) el = raiz.querySelector('img');
    return el ? (el.currentSrc || el.src || '') : '';
  }

  /* Nombre, variante y foto para el aviso -- instante 0, del DOM, siempre
     partiendo del formulario que se envio. El JSON de la variante
     seleccionada (cuando existe) es la fuente mas fiable: no escanea el DOM
     de la galeria en absoluto, usa la URL que Shopify ya asocio a esa
     variante. El DOM es respaldo solo cuando ese JSON no existe (producto sin
     variantes reales -- unless product.has_only_default_variant lo omite). */
  function datosParaAviso(form) {
    var raiz = raizDelFormulario(form);
    var out = { nombre: '', variante: '', foto: '' };

    var js = raiz.querySelector('[data-selected-variant]');
    if (js) {
      try {
        var v = JSON.parse(js.textContent);
        /* "Default Title" NO es una variante: se trata como ausencia. */
        out.variante = (v.public_title && v.public_title !== 'Default Title') ? v.public_title : '';
        var nombre = v.name || '';
        var cola = ' - ' + out.variante;
        if (out.variante && nombre.slice(-cola.length) === cola) nombre = nombre.slice(0, -cola.length);
        out.nombre = nombre;
        if (v.featured_image && v.featured_image.src) {
          out.foto = (v.featured_image.src.indexOf('//') === 0 ? 'https:' : '') + v.featured_image.src;
        } else if (v.featured_media && v.featured_media.id) {
          out.foto = fotoDeRaiz(raiz, v.featured_media.id);
        }
      } catch (e) {}
    }
    if (!out.nombre) {
      var t = raiz.querySelector('.product__title, .product-card-v2__title, .product-card__title, .pcard__title');
      if (t) out.nombre = t.textContent.replace(/\s+/g, ' ').trim();
    }
    if (!out.foto) out.foto = fotoDeRaiz(raiz, null);
    return out;
  }

  /* ENMIENDA 4, 2026-08-24. CORREGIDO el mismo dia: el dueno reporto
     "200,000 piezas" pintado un instante, corregido despues a "1,000 piezas"
     -- una razon de x200 exacta.

     LA PREMISA ERA FALSA: se penso que "step" era un MULTIPLICADOR (cuantas
     piezas trae cada "unidad" de la casilla) y que la casilla contaba
     "unidades". Verificado hoy en 23 tarjetas reales de HOME (script de
     verificacion, sin excepcion): el VALOR DE LA CASILLA ya es la cuenta de
     piezas -- coincide exactamente con el texto "Formato de venta: N
     piezas" en las 23. `step` es solo cuanto suma el boton +, no un
     multiplicador: con "Formato de venta: 12 piezas" la casilla trae
     value="12" (no "1"), con "450 piezas" trae value="450". La formula
     anterior hacia cantidad(=step en el estado inicial) x step = step^2 --
     con step=200 y la cantidad ya subida a 1000 via el boton +, salian los
     200,000 exactos que vio el dueno (1000 x 200).

     El arreglo: las piezas instantaneas SON el valor de la casilla, sin
     multiplicar por nada. form.elements['quantity'] funciona tanto si el
     input de cantidad esta ANIDADO en el form como si esta fuera con
     form="<id>" (el patron que usa <quantity-input> en tarjeta y PDP) -- es
     la coleccion nativa de elementos asociados del formulario, no un
     querySelector de DOM.

     Por que esto SIGUE siendo seguro pintarlo al instante (no es una
     adivinanza): la casilla de cantidad ES el valor que se manda tal cual
     en el campo "quantity" de /cart/add.js -- Shopify agrega exactamente esa
     cifra, sin transformarla. No hay ningun paso entre "leer la casilla" y
     "lo que el servidor agrega" que pueda discrepar salvo que la propia
     peticion FALLE (agotado, limite, red) -- y esos casos NO pintan un
     numero optimista: rematarAviso() los detecta por la diferencia real de
     item_count y corrige o cancela, sin que el usuario vea saltar la cifra
     en el camino feliz. */
  function piezasDelFormulario(form) {
    var qty = form && form.elements ? form.elements['quantity'] : null;
    if (!qty) return null;
    var cantidad = parseInt(qty.value, 10);
    if (!(cantidad > 0)) return null;
    return cantidad;
  }

  /* Cierra el aviso con la cifra REAL que entro, o lo retira si no entro nada.
     entraron = item_count despues - item_count antes. Sirve igual para el
     exito completo y para el parcial, y NO depende del texto del 422 (que
     viene localizado en 6 idiomas y no distingue los dos casos). */
  function rematarAviso(antes, ahora) {
    if (antes === null || ahora === null || !(ahora - antes > 0)) {
      window.MahaAviso.cancelar();
      return;
    }
    actualizarContadorIcono(ahora);
    marcarCajonSucio();
    window.MahaAviso.piezas(ahora - antes);
  }

  function agregarConAviso(form, config, original) {
    var datos, antes;
    try {
      datos = datosParaAviso(form);
      antes = contadorActual();
      /* AQUI esta la ganancia entera: se sustituye el cajon por los totales. */
      if (config && config.body && typeof config.body.set === 'function') {
        config.body.set('sections', 'cart-aviso-totales');
      }
      /* Aparece YA, con nombre y variante, y el hueco de la cifra reservado. */
      window.MahaAviso.mostrar(datos);
      /* ENMIENDA 4: la cifra se pinta EN EL CLIC, no se espera al servidor.
         rematarAviso() mas abajo la vuelve a poner con el numero REAL en
         cuanto responde -- si coincide con este no se nota nada; si difiere
         (p.ej. un 422 parcial) corrige sin mover el layout, el hueco ya
         estaba reservado desde antes. */
      var piezasInstante = piezasDelFormulario(form);
      if (piezasInstante > 0) window.MahaAviso.piezas(piezasInstante);
    } catch (e) {
      console.warn('[maha-aviso] fallo preparando, cae al flujo anterior:', e);
      return original.call(form, config);
    }

    var estado = { ok: true, status: 200 };
    return fetch(FoxTheme.routes.cart_add_url, config)
      .then(function (r) { estado.ok = r.ok; estado.status = r.status; return r.text(); })
      .then(function (texto) {
        var parsed = null;
        try { parsed = JSON.parse(texto); } catch (e) {}

        /* NI JSON de Shopify NI respuesta buena: es el limitador (429 con
           cuerpo HTML) o un fallo de transporte. Un 429 NO rechaza el fetch
           -- resuelve con status 429 --, asi que no cae en el .catch de mas
           abajo, y sin esta rama el usuario se quedaba SIN aviso y SIN
           mensaje. Se restituye el mismo trato que daba revertirOptimista. */
        if (!parsed && !estado.ok) {
          /* NO es JSON: el 429 de Cloudflare ("Verifying your connection")
             u otro cuerpo no-JSON. Se detecta y se trata como fallo de
             plataforma -- nunca se intenta parsear y rezar. */
          window.MahaAviso.cancelar();
          avisarEnTarjeta(form, estado.status === 429
            ? 'No pudimos agregar el producto ahora mismo. Vuelve a intentarlo en unos segundos.'
            : 'No hay suficiente inventario disponible.');
          return;
        }

        if (parsed && (parsed.status || parsed.errors || parsed.description)) {
          /* handleCartError() ya esta parchado (parcharDisplayFormErrors,
             mas arriba) para pasar por avisarEnTarjeta() y nunca por
             alert() ni con texto vacio -- 422 con descripcion usa la
             descripcion real de Shopify; sin ella, "No hay suficiente
             inventario disponible.". */
          if (typeof form.handleCartError === 'function') form.handleCartError(parsed);
          else avisarEnTarjeta(form, parsed.description || 'No hay suficiente inventario disponible.');

          /* UNA sola peticion, y solo en este camino: saber si entro algo. */
          return fetch(FoxTheme.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
            .then(function (r2) { return r2.text(); })
            .then(function (t2) {
              var carro = null;
              try { carro = JSON.parse(t2); } catch (e) {}
              rematarAviso(antes, carro && typeof carro.item_count === 'number' ? carro.item_count : null);
            })
            .catch(function () { window.MahaAviso.cancelar(); });
        }

        /* ENMIENDA 3: al llegar la respuesta, product_title/variant_title la
           corrigen si difieren de lo que se leyo del DOM al hacer clic. Es la
           MISMA respuesta que ya trae las piezas (parsed): no hay una
           peticion extra. parsed.image es el propio /cart/add.js identificando
           la foto DE ESE articulo -- la fuente de identidad mas autoritativa
           que existe, mejor que cualquier lectura del DOM. */
        try {
          if (parsed && typeof parsed === 'object' && window.MahaAviso.corregir) {
            var correccion = {};
            var hayCorreccion = false;
            if (parsed.product_title && parsed.product_title !== datos.nombre) {
              correccion.nombre = parsed.product_title;
              hayCorreccion = true;
            }
            var varianteServidor = (parsed.variant_title && parsed.variant_title !== 'Default Title') ? parsed.variant_title : '';
            if (varianteServidor !== datos.variante) {
              correccion.variante = varianteServidor;
              hayCorreccion = true;
            }
            if (parsed.image && parsed.image !== datos.foto) {
              correccion.foto = parsed.image;
              hayCorreccion = true;
            }
            if (hayCorreccion) window.MahaAviso.corregir(correccion);
          }
        } catch (e) {}

        rematarAviso(antes, contadorDeSecciones(parsed));
        try {
          document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: parsed } }));
        } catch (e) {}
      })
      .catch(function (error) {
        /* El fetch mismo fallo (red cortada, CORS, abortado) -- distinto de
           un 429/no-JSON, que ya se resolvio arriba sin llegar aqui. */
        window.MahaAviso.cancelar();
        avisarEnTarjeta(form, String(error && error.message).indexOf('429') !== -1
          ? 'No pudimos agregar el producto ahora mismo. Vuelve a intentarlo en unos segundos.'
          : 'Revisa tu conexión e inténtalo de nuevo.');
        console.warn('[maha-aviso]', error);
      })
      .finally(function () {
        if (form.submitButtonElement) {
          form.submitButtonElement.classList.remove('btn--loading');
          form.submitButtonElement.removeAttribute('aria-disabled');
        }
      });
  }

  /* ENMIENDA 5 / 9.3, 2026-08-24 -- RETIRADO (reaplicado: se habia perdido en
     una sincronizacion posterior con el remoto). Este listener era la ultima
     puerta que el encargo original (Fase 3) pidio cerrar: interceptaba el
     clic del icono en fase de CAPTURA, cancelaba la navegacion nativa y
     abria el cajon (refrescandolo primero si estaba "sucio"). El dueno
     confirmo que el icono debe NAVEGAR a /cart, no abrir nada.

     Ya no hace falta ninguna sustitucion aqui: sections/header.liquid y
     sections/mobile-sticky-bar.liquid dejan de emitir aria-controls="CartDrawer"
     en el icono cuando settings.maha_aviso_activo esta encendido (Enmienda
     9.3), asi que ModalComponent.connectedCallback (assets/theme.js) nunca
     engancha su propio listener ahi tampoco. El <a href="{{ routes.cart_url }}">
     navega tal cual lo sirvio el servidor. Ademas assets/cart-aviso.css
     (Enmienda 9.2/10) fuerza a #CartDrawer a quedarse fuera de pantalla e
     inerte aunque algo le ponga [open]/[active].

     marcarCajonSucio() sigue llamandose desde rematarAviso(): no estorba, y
     deja la marca lista por si algun dia una puerta legitima (design mode,
     un tema distinto) SI abre el cajon a proposito. Con el interruptor
     APAGADO esto nunca importo: avisoActivo() era falso y el bloque salia en
     la primera linea, asi que el camino viejo (icono abre cajon) sigue
     exactamente igual que siempre en ese modo. */

  /* ARREGLO DEL ALERT VACIO, 2026-08-24 -- reportado por el dueno: "maha.com.mx
     dice" con el mensaje EN BLANCO al agregar desde el Home.

     CAUSA RAIZ, confirmada reproduciendo con interceptacion local (route.fulfill),
     no con la tienda real -- hoy saturada por las pruebas del propio proyecto:

       assets/theme.js:3045-3056, ProductForm.displayFormErrors(errorMessage):
         this.formErrorMessage = this.formErrorMessage ||
           this.querySelector('.product-form__error-message');
         if (!this.formErrorMessage) {
           if (errorMessage !== false) alert(errorMessage);   <-- AQUI
         } else { ... }

       NINGUNA plantilla de tarjeta (card-product*.liquid, usadas en Home,
       coleccion y busqueda) trae .product-form__error-message -- solo la
       PDP (snippets/buy-buttons.liquid) y los bundles la traen. Por eso el
       dueno lo vio desde el Home y no desde una ficha.

       El disparador real: ProductForm.handleCartError(parsedState) (theme.js:3090)
       llama this.displayFormErrors(parsedState.description). Cuando Shopify
       responde con JSON valido (no la pagina HTML de Cloudflare -- ESA la
       intercepta bien assets/cart-mayoreo.js mas abajo, verificado, no
       dispara alert) pero con description:"" (vacia, presente pero sin
       texto), '' !== false, y sin elemento de error en la tarjeta -> alert('').
       Reproducido exacto con interceptacion local: dialog.message() === "".

     EL ARREGLO no toca assets/theme.js (works everywhere else: PDP, bundles,
     el resto del tema). displayFormErrors() es un CAMPO de clase (arrow
     function), instalado en CADA INSTANCIA del formulario -- se puede
     sobrescribir por formulario, igual que ya se hace con
     handleFormSubmission un poco mas abajo. Condicionado a avisoActivo():
     con el interruptor apagado, displayFormErrors() nunca se toca y el
     camino viejo (incluido su alert(), si algun dia vuelve a dispararse)
     queda IDENTICO a hoy -- el suelo no cambia. */
  function parcharDisplayFormErrors(form) {
    if (!form || form.__mahaDisplayErrorsPatched) return;
    if (typeof form.displayFormErrors !== 'function') return;
    form.__mahaDisplayErrorsPatched = true;
    var nativo = form.displayFormErrors;
    form.displayFormErrors = function (errorMessage) {
      if (!avisoActivo()) return nativo.call(form, errorMessage);
      if (errorMessage === false || errorMessage === undefined) {
        var raiz = raizDelFormulario(form);
        if (raiz === document) raiz = form;
        var previo = raiz.querySelector('.maha-agregar-error');
        if (previo) { clearTimeout(previo.__mahaTimer); previo.hidden = true; }
        return;
      }
      /* Nunca un mensaje vacio: si el servidor no mando texto (422 sin
         description, el caso reproducido), se usa el mensaje propio en
         espanol acordado para "sin inventario" -- es la causa mas comun de
         un 422 sin descripcion en este tema. */
      avisarEnTarjeta(form, errorMessage || 'No hay suficiente inventario disponible.');
    };
  }

  function parchearFormulario(form) {
    if (!form || form.__mahaAgregarOptimistaPatched) return;
    if (typeof form.handleFormSubmission !== 'function') return;
    form.__mahaAgregarOptimistaPatched = true;
    parcharDisplayFormErrors(form);

    var original = form.handleFormSubmission;

    form.handleFormSubmission = function (config) {
      /* CARRITO-AVISO: si el aviso esta activo (ajuste del tema), este es el
         camino. El de abajo, con cajon optimista, se conserva intacto para
         cuando se apague el ajuste. */
      if (avisoActivo()) return agregarConAviso(form, config, original);

      var datos;
      var cartDrawerEl;
      var sectionId;
      try {
        if (window.FoxTheme && FoxTheme.settings && FoxTheme.settings.cartType === 'page') {
          return original.call(form, config);
        }
        cartDrawerEl = document.querySelector('cart-drawer');
        if (!cartDrawerEl) return original.call(form, config);
        sectionId = getSectionId(cartDrawerEl);
        if (!sectionId) return original.call(form, config);

        datos = extraerDatosTarjeta(form);

        // 1) Abrir el cajon YA, mismo frame del clic, sin esperar a la red.
        cartDrawerEl.show(form.lastSubmittedElement || null);

        // 2) Pintar la fila provisional.
        var bodyVivo = document.querySelector('#CartDrawerBody-' + sectionId) || document.querySelector('[id^="CartDrawerBody-"]');
        if (bodyVivo) {
          var lista = bodyVivo.querySelector('ul, ol') || bodyVivo;
          lista.insertBefore(construirFilaOptimista(datos), lista.firstChild);
        }
      } catch (e) {
        console.warn('[maha-agregar-optimista] fallo preparando el optimismo, cae al flujo original:', e);
        return original.call(form, config);
      }

      // 3) UN SOLO fetch. Nada de GET /cart.js despues.
      fetch(FoxTheme.routes.cart_add_url, config)
        .then(function (response) { return response.json(); })
        .then(function (parsedState) {
          if (parsedState && (parsedState.status || parsedState.errors || parsedState.description)) {
            /* PDP-MENSAJE-STOCK 2026-08-21: aqui la tienda SI contesto, y su
               texto es el bueno -- Shopify lo manda ya localizado, cosa que un
               literal nuestro no puede igualar en los 6 idiomas del tema.
               Se revierte la fila provisional igual que antes, pero el mensaje
               lo pinta UNICAMENTE el nativo, en la linea siguiente.
               El else es la red de seguridad: si algun dia el formulario no
               expusiera handleCartError, el aviso propio vuelve a entrar y el
               usuario no se queda sin explicacion. */
            quitarFilaOptimista();
            if (typeof form.handleCartError === 'function') form.handleCartError(parsedState);
            else avisarEnTarjeta(form, parsedState.description || parsedState.message || 'No se pudo agregar. Intenta de nuevo.');
            return;
          }
          try {
            aplicarRespuestaReal(form, cartDrawerEl, sectionId, datos, parsedState);
          } catch (e) {
            console.warn('[maha-agregar-optimista] fallo aplicando la respuesta real, la fila provisional puede quedar visible:', e);
          }
        })
        .catch(function (error) {
          if (String(error && error.message).indexOf('429') !== -1) {
            revertirOptimista(form, 'Demasiados intentos seguidos. Espera un momento e intenta de nuevo.');
          } else {
            revertirOptimista(form, 'No se pudo agregar. Intenta de nuevo.');
          }
          console.warn('[maha-agregar-optimista]', error);
        })
        .finally(function () {
          if (form.submitButtonElement) {
            form.submitButtonElement.classList.remove('btn--loading');
            form.submitButtonElement.removeAttribute('aria-disabled');
          }
        });
    };
  }

  function escanear(root) {
    var forms = (root || document).querySelectorAll('form[is="product-form"]');
    for (var i = 0; i < forms.length; i++) parchearFormulario(forms[i]);
  }

  // Red de seguridad: formulario enviado ANTES de que el observer/escaneo lo alcance.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form && form.matches && form.matches('form[is="product-form"]')) {
      parchearFormulario(form);
    }
  }, true);

  function iniciar() {
    escanear(document);
    if (window.MutationObserver) {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (node.nodeType !== 1) continue;
            if (node.matches && node.matches('form[is="product-form"]')) parchearFormulario(node);
            if (node.querySelectorAll) escanear(node);
          }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
/* === /MAHA-AGREGAR-OPTIMISTA === */
